{
	"actions": {
		"title": "Acciones",
		"save": "Guardar",
		"edit": "Editar",
		"delete": "Eliminar",
		"remove": "Quitar",
		"deleting": "Eliminando",
		"see": "Ver",
		"open": "Abrir",
		"back": "Volver",
		"close": "Cerrar",
		"cancel": "Cancelar",
		"download": "Descargar"
	},
	"theme": {
		"light": "Claro",
		"dark": "Oscuro",
		"toggle": "Cambiar tema"
	},
	"language": "Idioma",
	"auth": {
		"pets": "Mascotas",
		"logoAriaLabel": "Logo de Mascotas",
		"links": {
			"forgotPassword": "Olvidé mi contraseña",
			"createAccount": "Crear cuenta",
			"backToLogin": "Volver al inicio de sesión",
			"alreadyHaveAccount": "Ya tengo una cuenta"
		},
		"login": {
			"title": "Iniciar sesión",
			"submit": "Entrar",
			"loadingAria": "Iniciando sesión"
		},
		"forgotPassword": {
			"title": "Olvidé mi contraseña",
			"submit": "Enviar token",
			"loadingAria": "Enviando token"
		},
		"resetPassword": {
			"title": "Restablecer contraseña",
			"submit": "Guardar nueva contraseña",
			"loadingAria": "Guardando nueva contraseña"
		},
		"signup": {
			"title": "Crear cuenta",
			"submit": "Crear cuenta",
			"loadingAria": "Creando cuenta",
			"termsLabel": "Leí y acepto los",
			"termsLinkLabel": "términos de uso",
			"options": {
				"referralSource": {
					"indicacao": "Recomendación",
					"redesSociais": "Redes sociales",
					"pesquisaGoogle": "Búsqueda en Google",
					"veterinario": "Veterinario",
					"outro": "Otro"
				}
			}
		},
		"verify": {
			"title": "Confirmar correo electrónico",
			"submit": "Confirmar",
			"submitAria": "Confirmar correo electrónico",
			"loadingAria": "Confirmando correo electrónico",
			"resend": "Reenviar token",
			"resending": "Reenviando…",
			"resendIn": "Reenviar en { seconds }s"
		},
		"acceptInvite": {
			"title": {
				"loading": "Aceptar invitación",
				"needPassword": "Finaliza tu acceso",
				"redirecting": "Redirigiendo…"
			},
			"info": {
				"needPassword": "Crea una contraseña para completar el registro y acceder a la mascota.",
				"invitedEmail": "Correo de la invitación: <strong>{email}</strong>"
			},
			"loading": {
				"validating": "Validando invitación…",
				"redirecting": "Redirigiendo…"
			},
			"submit": "Finalizar y acceder",
			"submitAria": "Finalizar registro y acceder",
			"retry": "Intentar de nuevo",
			"errors": {
				"missing_token": {
					"title": "Enlace no válido",
					"message": "El enlace de la invitación está incompleto. Solicita una nueva invitación para acceder al sistema."
				},
				"invalid_token": {
					"title": "Invitación no válida",
					"message": "Solicita una nueva invitación para acceder al sistema."
				},
				"invalid_invite": {
					"title": "Invitación no válida",
					"message": "Los datos de esta invitación están incompletos. Solicita una nueva invitación al tutor para acceder al sistema."
				},
				"invite_expired": {
					"title": "Invitación expirada",
					"message": "Esta invitación expiró. Solicita una nueva invitación al tutor para acceder al sistema."
				},
				"invite_revoked": {
					"title": "Invitación cancelada",
					"message": "Esta invitación fue cancelada por el tutor. Solicita una nueva invitación para acceder al sistema."
				},
				"invite_rejected": {
					"title": "Invitación rechazada",
					"message": "Esta invitación fue rechazada. Pide al tutor una nueva invitación si aún deseas acceder."
				},
				"invite_used": {
					"title": "Invitación ya utilizada",
					"message": "Esta invitación ya fue aceptada. Inicia sesión para acceder al sistema."
				},
				"user_blocked": {
					"title": "Acceso bloqueado",
					"message": "Tu cuenta no está habilitada para acceder. Contacta al tutor o al soporte."
				},
				"pet_not_found": {
					"title": "Mascota no disponible",
					"message": "La mascota de esta invitación ya no está disponible. Solicita una nueva invitación al tutor."
				},
				"bad_request": {
					"title": "No se pudo procesar",
					"message": "No se pudo procesar la invitación. Intenta abrir el enlace de nuevo o solicita una nueva invitación."
				},
				"db_error": {
					"title": "Error al guardar",
					"message": "Ocurrió un error al completar el registro. Inténtalo de nuevo en unos instantes."
				},
				"no_jwt": {
					"title": "No se pudo completar",
					"message": "No se pudo iniciar tu sesión. Inténtalo de nuevo o inicia sesión."
				},
				"unauthorized": {
					"title": "Sesión expirada",
					"message": "Tu sesión expiró o no es válida. Inténtalo de nuevo o inicia sesión."
				},
				"generic": {
					"title": "Error al aceptar la invitación",
					"message": "No se pudo completar la aceptación de la invitación. Inténtalo de nuevo en unos instantes."
				}
			}
		},
		"rejectInvite": {
			"title": {
				"loading": "Rechazar invitación",
				"confirm": "Rechazar invitación",
				"done": "Invitación rechazada",
				"error": "No se pudo rechazar"
			},
			"info": {
				"confirm": "¿Seguro que deseas rechazar esta invitación para acceder a un pet?",
				"fromTutor": "Enviado por {name}"
			},
			"loading": {
				"validating": "Validando invitación…"
			},
			"submit": "Rechazar invitación",
			"submitting": "Rechazando…",
			"success": "Invitación rechazada con éxito. No recibirás más notificaciones sobre ella.",
			"errors": {
				"missing_token": "El enlace está incompleto. Abre de nuevo el correo de invitación.",
				"invalid_token": "Esta invitación no es válida o ya fue procesada.",
				"invalid_invite": "Los datos de esta invitación están incompletos.",
				"invite_expired": "Esta invitación expiró.",
				"invite_revoked": "Esta invitación fue cancelada por el tutor.",
				"invite_rejected": "Esta invitación ya fue rechazada.",
				"invite_used": "Esta invitación ya fue aceptada.",
				"generic": "No se pudo rechazar la invitación. Inténtalo de nuevo en unos instantes."
			}
		},
		"errors": {
			"invalidCredentials": "Credenciales no válidas",
			"emailNotVerified": "Confirma tu correo antes de entrar",
			"accountDeleted": "Esta cuenta fue eliminada. Contacta al soporte.",
			"accountBlocked": "Esta cuenta está bloqueada. Contacta al soporte.",
			"loginFailed": "Error al iniciar sesión",
			"emailInUse": "Este correo ya está en uso",
			"passwordConfirmMismatch": "Las contraseñas no coinciden",
			"signupFailed": "Error al crear la cuenta",
			"tokenExpired": "El token expiró. Solicita otro.",
			"tokenInvalid": "Token no válido",
			"verifyTokenExpired": "El token expiró. Solicita uno nuevo.",
			"verifyTokenInvalid": "Token no válido",
			"verifyResendEmailInvalid": "Introduce un correo válido para reenviar",
			"verifyResendFailed": "Error al reenviar el token"
		},
		"messages": {
			"forgotPasswordInfo": "Si existe una cuenta con ese correo, enviaremos un token.",
			"resetPasswordSuccess": "Contraseña actualizada. Ya puedes entrar.",
			"verifySuccess": "Correo confirmado. Ya puedes entrar.",
			"verifyResendSuccess": "Enviamos un nuevo token a tu correo."
		}
	},
	"emptyState": {
		"generic": {
			"default": {
				"title": "No se encontraron resultados",
				"description": "Intenta ajustar los filtros o crear un nuevo elemento.",
				"action": "Crear elemento",
				"actionAriaLabel": "Crear nuevo elemento"
			},
			"search": {
				"title": "No se encontró nada",
				"description": "Intenta cambiar los filtros o buscar otro término."
			},
			"permission": {
				"title": "Acción no disponible",
				"description": "Aún no tienes permiso para crear este elemento."
			}
		},
		"pets": {
			"user": {
				"title": "¡Qué bueno tenerte aquí!",
				"description": "Registra tu primera mascota para empezar el seguimiento.",
				"action": "+ Mascota",
				"actionAriaLabel": "Registrar nueva mascota"
			},
			"userFiltered": {
				"title": "No se encontraron mascotas",
				"description": "Ninguna mascota coincide con los filtros actuales. Prueba limpiar la búsqueda o cambiar especie/sexo."
			},
			"vet": {
				"title": "Aún no hay mascotas compartidas",
				"description": "Cuando un tutor comparta una mascota contigo, aparecerá aquí."
			},
			"master": {
				"title": "No se encontraron mascotas",
				"description": "Intenta limpiar los filtros o seleccionar un tutor específico."
			},
			"masterMine": {
				"title": "No tienes mascotas registradas",
				"description": "Registra una mascota o cambia el ámbito para ver mascotas de otros tutores."
			},
			"masterMineFiltered": {
				"title": "No se encontraron mascotas",
				"description": "Ninguna de tus mascotas coincide con los filtros actuales. Prueba limpiar la búsqueda o cambiar especie/sexo."
			},
			"masterWithTutor": {
				"title": "No se encontraron mascotas para este tutor",
				"description": "Intenta limpiar los filtros o seleccionar otro tutor."
			},
			"masterWithTutorFiltered": {
				"title": "No se encontraron mascotas para este tutor",
				"description": "Ninguna mascota de este tutor coincide con los filtros actuales. Prueba limpiar la búsqueda o cambiar especie/sexo."
			},
			"masterAll": {
				"title": "No se encontraron mascotas",
				"description": "No hay mascotas de otros tutores con los filtros actuales."
			},
			"masterAllFiltered": {
				"title": "No se encontraron mascotas",
				"description": "Ninguna mascota de otros tutores coincide con los filtros actuales."
			},
			"onlyWithAlerts": {
				"title": "No hay mascotas con alertas",
				"description": "No se encontraron mascotas con alertas activas para los filtros seleccionados."
			}
		}
	},
	"form-fields": {
		"email": "Correo electrónico",
		"emailPlaceholder": "tu@email.com",
		"password": "Contraseña",
		"passwordPlaceholder": "Tu contraseña",
		"token": "Token",
		"tokenPlaceholder": "Pega el token recibido",
		"newPassword": "Nueva contraseña",
		"newPasswordPlaceholder": "Mínimo 8 caracteres",
		"passwordConfirm": "Confirmar contraseña",
		"passwordConfirmPlaceholder": "Repite la contraseña",
		"fullName": "Nombre completo",
		"fullNamePlaceholder": "Tu nombre",
		"preferredName": "Nombre preferido",
		"preferredNamePlaceholder": "Cómo quieres que te llamen",
		"referralSource": "¿Cómo nos conociste?",
		"referralSourcePlaceholder": "Selecciona",
		"referralDetail": "¿Quién te recomendó o dónde nos encontraste?",
		"referralDetailPlaceholder": "Ej.: Instagram, amigo, clínica…",
		"measuredAt": "Fecha de pesaje",
		"weightKg": "Peso (kg)",
		"weightKgPlaceholder": "Ej.: 2,50"
	},
	"validation": {
		"required": "*Campo obligatorio",
		"requiredTerms": "*Acepta los términos para continuar",
		"min": "*Introduce un valor mayor o igual que el mínimo permitido",
		"minlength": "*Mínimo de {requiredLength} caracteres",
		"invalidEmail": "*Correo electrónico no válido",
		"invalidValue": "*Valor no válido",
		"invalidDate": "*Fecha no válida",
		"futureDate": "*La fecha no puede ser posterior a hoy",
		"adoptionBeforeBirth": "*La fecha de adopción no puede ser anterior al nacimiento",
		"passwordMismatch": "*Las contraseñas no coinciden"
	},
	"form-filter": {
		"title": {
			"list": "Lista de filtros",
			"filterOf": "Filtro {tipo}"
		},
		"placeholders": {
			"name": "Buscar por nombre",
			"species": {
				"title": "Especie"
			},
			"sex": {
				"title": "Sexo"
			},
			"tutor": {
				"selectTutor": "Seleccionar tutor",
				"scope": "Ámbito",
				"scopeMine": "Mis mascotas",
				"scopeAll": "Todos los tutores",
				"search": "Buscar tutor",
				"choose": "Elige un tutor",
				"noneFound": "No hay tutores disponibles",
				"lookingPetFrom": "Viendo las mascotas de:",
				"noneSelectedMine": "Mostrando tus mascotas.",
				"noneSelectedAll": "Mostrando mascotas de todos los tutores.",
				"totalPets": "Número total de mascotas:"
			}
		},
		"buttons": {
			"clear": "Limpiar",
			"clearSelection": "Limpiar selección",
			"refreshList": "Actualizar lista",
			"onylWithAlerts": "Solo mascotas con alertas"
		},
		"total": "{total, plural, =0{<strong>no se admiten mascotas</strong>} =1{<strong>{total}</strong> mascota} other{<strong>{total}</strong> mascotas}}"
	},
	"home": {
		"alerts": {
			"title": "Alertas",
			"refresh": "Actualizar",
			"refreshing": "Actualizando...",
			"viewMore": "Ver más",
			"pageTitle": "Alertas",
			"pageSubtitle": "Todos los alertas de tus mascotas",
			"pageTitlePet": "Alertas de la mascota",
			"pageSubtitlePet": "Alertas y pendientes de esta mascota",
			"tabs": {
				"all": "Todos",
				"danger": "Urgentes",
				"warn": "Pronto",
				"info": "Informativos"
			},
			"groups": {
				"danger": "Urgentes",
				"warn": "Próximos",
				"info": "Informativos"
			},
			"empty": {
				"title": "¡Todo está al día!",
				"description": "No se encontraron alertas para las mascotas seleccionadas."
			},
			"preventives": {
				"vermifugo": "Desparasitante",
				"antiPulgas": "Antipulgas"
			},
			"items": {
				"birthday": "Cumpleaños",
				"birthdayWithYears": "¡Felicidades! {years} años",
				"vaccine": "Vacuna {type}",
				"vaccineAnnualSoon": "La vacunación anual está próxima",
				"vaccineAnnualOverdue": "Vacunación anual atrasada",
				"vaccineIndividualSoon": "Vacuna contra {name} en breve",
				"vaccineIndividualOverdue": "Vacuna contra {name} atrasada",
				"vaccineMissing": "Ninguna vacuna registrada",
				"glycemia": "Medición de glucosa",
				"treatment": "{name}",
				"preventive": "{kind}",
				"preventiveFallback": "Preventivo",
				"visit": "Consulta",
				"weightNever": "Nunca pesado",
				"weightStale": "Sin pesaje hace más de 6 meses"
			},
			"time": {
				"today": "hoy",
				"inDays": "en {days} días",
				"inDaysWithDate": "en {days} días · {date}",
				"overdue": "vencido hace {days} días",
				"overdueWithDate": "hace {days} días · prevista el {date}",
				"dueToday": "hoy · {date}",
				"pending": "Pendiente",
				"lastWeighing": "última: {date}",
				"withClock": "{label} · {time}"
			}
		}
	},
	"list": {
		"errors": {
			"loadPets": "No se pudieron cargar las mascotas.",
			"loadAlerts": "No se pudieron cargar las alertas.",
			"loadTutors": "No se pudieron cargar los tutores.",
			"deletePet": "No se pudo eliminar la mascota.",
			"leaveSharedPet": "No se pudo quitar la mascota de tu lista.",
			"loadMorePets": "No se pudieron cargar más mascotas."
		},
		"loadError": {
			"title": "No se pudieron cargar las mascotas",
			"description": "Verifique su conexión e intente nuevamente.",
			"retry": "Intentar nuevamente"
		},
		"loadingMorePets": "Cargando más mascotas...",
		"loadingPetsAria": "Cargando mascotas",
		"petCard": {
			"tutor": "Tutor",
			"deleteAria": "Eliminar mascota",
			"leaveAria": "Quitar mascota de la lista",
			"fallbackName": "Mascota"
		},
		"deletePet": {
			"title": "¿Eliminar mascota?",
			"contentWithName": "¿Seguro que deseas eliminar a \"{name}\"?",
			"contentGeneric": "¿Seguro que deseas eliminar esta mascota?",
			"confirm": "Eliminar",
			"cancel": "Cancelar"
		},
		"leaveSharedPet": {
			"title": "¿Quitar mascota de tu lista?",
			"contentWithName": "¿Seguro que deseas quitar a \"{name}\" de tu lista? Perderás el acceso a esta mascota.",
			"contentGeneric": "¿Seguro que deseas quitar esta mascota de tu lista?",
			"confirm": "Quitar",
			"cancel": "Cancelar",
			"success": "Mascota quitada de tu lista."
		},
		"vetInvites": {
			"title": "Mascotas por aprobar",
			"count": "{count, plural, =0{ninguna invitación} =1{1 invitación} other{{count} invitaciones}}",
			"refresh": "Actualizar",
			"close": "Cerrar",
			"ok": "Ok",
			"approve": "Aprobar",
			"reject": "Rechazar",
			"columns": {
				"pet": "Mascota",
				"tutor": "Tutor",
				"status": "Estado",
				"actions": "Acciones"
			},
			"emptyTitle": "No se encontraron invitaciones",
			"emptyDescription": "Cuando un tutor comparta una mascota contigo, aparecerá aquí.",
			"emailMissing": "No se pudo identificar el correo del usuario en el token.",
			"loadFailed": "No se pudieron cargar las invitaciones.",
			"approveSuccess": "Acceso aprobado.",
			"approveFailed": "No se pudo aprobar el acceso.",
			"rejectTitle": "¿Rechazar invitación?",
			"rejectContent": "No tendrás acceso a \"{petName}\". Tutor: {tutor}.",
			"rejectSuccess": "Invitación rechazada.",
			"rejectFailed": "No se pudo rechazar la invitación.",
			"status": {
				"pending": "Pendiente",
				"expired": "Expirado",
				"accepted": "Aceptado",
				"revoked": "Cancelado",
				"unknown": "—"
			}
		},
		"vaccines": {
			"loading": "Cargando vacunas",
			"close": "Cerrar",
			"ok": "Ok",
			"fallbackName": "Vacuna",
			"filters": {
				"searchLabel": "Vacuna",
				"searchPlaceholder": "Filtrar por vacuna o marca",
				"typeLabel": "Tipo",
				"typePlaceholder": "Tipo de vacuna",
				"typeClearAria": "Limpiar tipo de vacuna",
				"typeSearchPlaceholder": "Buscar tipo de vacuna",
				"typeSearchAria": "Buscar tipo de vacuna",
				"typeEmpty": "No se encontraron tipos",
				"productLabel": "Producto",
				"productPlaceholder": "Producto / marca comercial",
				"productClearAria": "Limpiar producto",
				"productSearchPlaceholder": "Buscar producto",
				"productSearchAria": "Buscar producto",
				"productEmpty": "No se encontraron productos"
			},
			"columns": {
				"vaccine": "Vacuna",
				"brand": "Marca",
				"dose": "Dosis",
				"administeredAt": "Aplicada el",
				"nextDoseAt": "Próxima dosis",
				"professional": "Veterinario",
				"clinic": "Clínica",
				"context": "Contexto",
				"location": "Lugar",
				"notes": "Observaciones",
				"actions": "Acciones"
			},
			"unknown": "No informado",
			"empty": {
				"title": "Ninguna vacuna aplicada",
				"description": "¿Qué tal programar la próxima? ¡Protege a tu mascota!"
			},
			"noResults": {
				"title": "No se encontraron vacunas",
				"description": "Intenta ajustar los filtros para encontrar lo que buscas."
			},
			"actions": {
				"editAria": "Editar vacuna",
				"deleteAria": "Eliminar vacuna"
			},
			"delete": {
				"title": "¿Eliminar aplicación de vacuna?",
				"contentWithName": "¿Seguro que deseas eliminar \"{name}\"?",
				"contentGeneric": "¿Seguro que deseas eliminar esta aplicación de vacuna?",
				"confirm": "Eliminar",
				"cancel": "Cancelar",
				"success": "Vacuna eliminada con éxito."
			},
			"errors": {
				"load": "No se pudieron cargar las vacunas.",
				"loadTypes": "No se pudieron cargar los tipos de vacuna.",
				"loadProducts": "No se pudieron cargar los productos de vacuna.",
				"delete": "No se pudo eliminar la vacuna."
			}
		},
		"preventives": {
			"loading": "Cargando preventivos",
			"protectionDays": "{days} días",
			"protectionMonths": "{months} meses",
			"filters": {
				"searchLabel": "Preventivo",
				"searchPlaceholder": "Filtrar por producto o tipo (collar, pipeta...)",
				"kindLabel": "Tipo",
				"kindPlaceholder": "Cuál",
				"kindClearAria": "Limpiar tipo"
			},
			"columns": {
				"kind": "Cuál",
				"method": "Tipo",
				"product": "Producto",
				"appliedAt": "Aplicada el",
				"nextDueAt": "Próxima dosis",
				"protection": "Protección",
				"notes": "Observaciones",
				"actions": "Acciones"
			},
			"empty": {
				"title": "Ningún preventivo registrado",
				"description": "¡Registra antipulgas y desparasitante para recordar las dosis!"
			},
			"noResults": {
				"title": "Ningún preventivo encontrado",
				"description": "Intenta ajustar los filtros para encontrar lo que buscas."
			},
			"actions": {
				"editAria": "Editar preventivo",
				"deleteAria": "Eliminar preventivo"
			},
			"delete": {
				"title": "¿Eliminar preventivo?",
				"contentWithName": "¿Seguro que deseas eliminar \"{name}\"?",
				"contentGeneric": "¿Seguro que deseas eliminar este preventivo?",
				"confirm": "Eliminar",
				"cancel": "Cancelar",
				"success": "Preventivo eliminado correctamente."
			},
			"errors": {
				"load": "No se pudieron cargar los preventivos.",
				"delete": "No se pudo eliminar el preventivo."
			}
		},
		"treatments": {
			"loading": "Cargando tratamientos",
			"close": "Cerrar",
			"ok": "Ok",
			"filters": {
				"searchLabel": "Filtro",
				"searchPlaceholder": "Filtrar por medicamento, motivo o veterinario",
				"statusLabel": "Estado",
				"statusPlaceholder": "Estado",
				"statusClearAria": "Limpiar estado"
			},
			"status": {
				"active": "Activo",
				"paused": "Pausado",
				"finished": "Finalizado",
				"draft": "Borrador",
				"cancelled": "Cancelado"
			},
			"schedule": {
				"daily": "Diario",
				"dailyTimes": "{count}x al día",
				"weekly": "Semanal",
				"monthly": "Mensual"
			},
			"form": {
				"tabsAria": "Tratamiento",
				"tabs": {
					"general": "General",
					"frequency": "Frecuencia y horarios",
					"dose": "Dosis",
					"package": "Envase y stock",
					"notes": "Notas",
					"plan": "Plan",
					"items": "Ítems",
					"validity": "Validez"
				},
				"fields": {
					"medName": "Medicamento",
					"medPresentation": "Presentación",
					"medManufacturer": "Fabricante",
					"conditions": "Condiciones clínicas",
					"startedAt": "Inicio",
					"durationMode": "Duración",
					"durationDays": "En días",
					"untilDate": "Fecha final",
					"vetName": "Veterinario",
					"reason": "Motivo",
					"frequencyMode": "Frecuencia",
					"times": "Horarios",
					"time": "Horario",
					"weeklyWeekdays": "Días de la semana",
					"monthlyMonthdays": "Días del mes",
					"doseValue": "Dosis",
					"doseUnit": "Unidad",
					"doseRoute": "Vía",
					"insulinKind": "Tipo de insulina",
					"insulinConcentration": "Concentración",
					"insulinDelivery": "Presentación",
					"openedAt": "Abierto el",
					"openedValidDays": "Dura tras abrir (días)",
					"discardAt": "Descartar el",
					"expiresAt": "Vencimiento",
					"amountTotal": "Cantidad total",
					"amountUnit": "Unidad",
					"amountRemaining": "Restante",
					"lowStockThreshold": "Alerta de stock bajo",
					"noteText": "Agregar nota",
					"planName": "Nombre del plan",
					"generalInstructions": "Instrucciones generales",
					"itemName": "Nombre del ítem",
					"details": "Detalles",
					"estimatedEndDate": "Fin estimado",
					"visit": "Consulta",
					"veterinarian": "Veterinario",
					"vetOther": "Otro",
					"vetCrmv": "CRMV",
					"hasPause": "Intervalo en el tratamiento",
					"pauseDays": "Días de pausa",
					"durationAgain": "Duración de nuevo (días)",
					"isInsulin": "Insulina"
				},
				"placeholders": {
					"conditions": "Seleccione una o más condiciones",
					"select": "Seleccione",
					"doseUnit": "ej.: UI, mg, ml",
					"doseRoute": "ej.: oral, SC",
					"amountUnit": "ej.: ml, comprimidos",
					"visit": "Vincular a una consulta"
				},
				"linkedPreventivesTitle": "Preventivos vinculados",
				"hints": {
					"noConditions": "Aún no hay condiciones registradas.",
					"noteSaveWithTreatment": "Esta nota se guardará junto con el tratamiento cuando haga clic en “Guardar”.",
					"visitLocked": "Consulta definida por la prescripción y no se puede cambiar."
				},
				"actions": {
					"removeTime": "Eliminar",
					"addTime": "Agregar horario",
					"saveNote": "Guardar nota",
					"addItem": "Añadir ítem",
					"removeItem": "Eliminar ítem",
					"registerPreventive": "Registrar como preventivo"
				},
				"duration": {
					"indefinite": "Indefinido",
					"continuous": "Continuo",
					"for_days": "Por días",
					"until_date": "Hasta una fecha"
				},
				"frequency": {
					"daily": "Diario",
					"weekly": "Semanal",
					"monthly": "Mensual"
				},
				"weekdays": {
					"0": "Dom",
					"1": "Lun",
					"2": "Mar",
					"3": "Mié",
					"4": "Jue",
					"5": "Vie",
					"6": "Sáb"
				},
				"insulin": {
					"kind": {
						"glargine": "Glargina",
						"pzi": "PZI / ProZinc",
						"lente": "Lente (Vetsulin)",
						"nph": "NPH",
						"detemir": "Detemir",
						"other": "Otro"
					},
					"concentration": {
						"U40": "U-40",
						"U100": "U-100",
						"other": "Otra"
					},
					"delivery": {
						"vial": "Frasco",
						"pen": "Pluma",
						"cartridge": "Cartucho"
					}
				},
				"errors": {
					"scheduleRequired": "Complete la frecuencia y al menos un horario.",
					"durationDaysRequired": "Indique la cantidad de días.",
					"untilDateRequired": "Indique la fecha final.",
					"vetRequired": "Informe el nombre y el CRMV del veterinario."
				},
				"successSave": "Tratamiento guardado con éxito.",
				"successEdit": "Tratamiento actualizado con éxito.",
				"errorSave": "No fue posible guardar el tratamiento.",
				"planSection": "Datos del plan",
				"itemsSection": "Ítems del plan",
				"itemsTabAria": "Ítems del tratamiento",
				"itemLabel": "Ítem {number}",
				"outerTabsAria": "Secciones del plan de tratamiento"
			},
			"validity": {
				"opened": "Abierto",
				"discard": "Descartar"
			},
			"columns": {
				"startedAt": "Inicio",
				"medication": "Medicamento",
				"dose": "Dosis",
				"schedule": "Frecuencia",
				"validity": "Validez tras abrir",
				"status": "Estado",
				"actions": "Acciones",
				"items": "Ítems",
				"vet": "Veterinario"
			},
			"empty": {
				"title": "Ningún tratamiento registrado",
				"description": "Registra un tratamiento y controla las dosis y la validez."
			},
			"noResults": {
				"title": "Ningún tratamiento encontrado",
				"description": "Intenta ajustar los filtros para encontrar lo que buscas."
			},
			"actions": {
				"editAria": "Editar tratamiento",
				"pauseAria": "Pausar tratamiento",
				"reactivateAria": "Reactivar tratamiento",
				"finishAria": "Finalizar tratamiento",
				"deleteAria": "Eliminar tratamiento",
				"viewAria": "Ver tratamiento"
			},
			"pause": {
				"success": "Tratamiento pausado."
			},
			"reactivate": {
				"success": "Tratamiento reactivado."
			},
			"finish": {
				"title": "¿Finalizar tratamiento?",
				"contentWithName": "¿Seguro que deseas finalizar \"{name}\"?",
				"contentGeneric": "¿Seguro que deseas finalizar este tratamiento?",
				"confirm": "Finalizar",
				"cancel": "Cancelar",
				"success": "Tratamiento finalizado."
			},
			"delete": {
				"title": "¿Eliminar tratamiento?",
				"contentWithName": "¿Seguro que deseas eliminar \"{name}\"? Esta acción no se puede deshacer.",
				"contentGeneric": "¿Seguro que deseas eliminar este tratamiento? Esta acción no se puede deshacer.",
				"confirm": "Eliminar",
				"cancel": "Cancelar",
				"success": "Tratamiento eliminado."
			},
			"errors": {
				"load": "No se pudieron cargar los tratamientos.",
				"status": "No se pudo actualizar el estado del tratamiento.",
				"delete": "No se pudo eliminar el tratamiento."
			}
		},
		"consultations": {
			"loading": "Cargando consultas",
			"close": "Cerrar",
			"ok": "Ok",
			"filters": {
				"visitedFromLabel": "Fecha consulta (desde)",
				"visitedToLabel": "Fecha consulta (hasta)",
				"nextVisitFromLabel": "Fecha retorno (desde)",
				"nextVisitToLabel": "Fecha retorno (hasta)",
				"kindLabel": "Tipo de consulta",
				"kindPlaceholder": "Tipo",
				"kindClearAria": "Limpiar tipo de consulta",
				"modeLabel": "Modalidad de consulta",
				"modePlaceholder": "Modalidad",
				"modeClearAria": "Limpiar modalidad de consulta",
				"vetLabel": "Veterinario",
				"vetPlaceholder": "Nombre o CRMV",
				"clinicLabel": "Clínica",
				"clinicPlaceholder": "Filtrar por clínica"
			},
			"kinds": {
				"routine": "Rutina",
				"emergency": "Emergencia",
				"follow_up": "Retorno",
				"return": "Retorno",
				"urgent": "Urgencia",
				"monitoring": "Seguimiento",
				"preoperative": "Preoperatorio",
				"postoperative": "Postoperatorio",
				"vaccination": "Vacunación",
				"exam": "Evaluación de examen",
				"other": "Otro"
			},
			"modes": {
				"home": "Domicilio",
				"clinic": "Clínica",
				"telehealth": "Teleatención",
				"campaign": "Campaña",
				"shelter": "Refugio",
				"other": "Otro"
			},
			"columns": {
				"visitedAt": "Fecha consulta",
				"nextVisitAt": "Fecha retorno",
				"kind": "Tipo",
				"mode": "Modalidad",
				"vet": "Veterinario",
				"clinic": "Clínica",
				"links": "Vínculos",
				"notes": "Notas",
				"actions": "Acciones"
			},
			"links": {
				"separator": " · ",
				"vaccine": "{count} vacuna",
				"vaccines": "{count} vacunas",
				"exam": "{count} examen",
				"exams": "{count} exámenes",
				"condition": "{count} condición",
				"conditions": "{count} condiciones"
			},
			"empty": {
				"title": "Ninguna consulta registrada",
				"description": "¿Qué tal programar un chequeo para tu mascota?"
			},
			"noResults": {
				"title": "Ninguna consulta encontrada",
				"description": "Prueba a ajustar los filtros para encontrar lo que buscas."
			},
			"actions": {
				"editAria": "Editar consulta",
				"deleteAria": "Eliminar consulta"
			},
			"delete": {
				"title": "¿Eliminar consulta?",
				"contentGeneric": "Esta acción no se podrá deshacer.",
				"confirm": "Eliminar",
				"cancel": "Cancelar",
				"success": "Consulta eliminada."
			},
			"errors": {
				"load": "No se pudieron cargar las consultas.",
				"delete": "No se pudo eliminar la consulta."
			},
			"form": {
				"tabsAria": "Pestañas del formulario de consulta",
				"tabs": {
					"general": "Información general",
					"vaccines": "Vacuna",
					"exams": "Exámenes",
					"diagnosis": "Diagnóstico y conductas",
					"finance": "Financiero",
					"history": "Relato y examen físico",
					"conduct": "Conductas realizadas",
					"prescription": "Prescripción y orientaciones",
					"documents": "Documentos"
				},
				"visitedAtDate": "Fecha de la visita",
				"visitedAtTime": "Hora",
				"visitType": "Tipo",
				"visitMode": "Modalidad",
				"clinic": "Clínica",
				"clinicPlaceholder": "Buscar clínica o lugar",
				"clinicOther": "Otro",
				"clinicName": "Nombre de la clínica / lugar",
				"clinicNamePlaceholder": "Ej.: Clínica X",
				"veterinarian": "Veterinario",
				"vetPlaceholder": "Buscar por nombre o CRMV",
				"vetOther": "Otro",
				"vetName": "Nombre del veterinario",
				"vetNamePlaceholder": "Nombre completo",
				"vetCrmv": "CRMV",
				"vetCrmvPlaceholder": "Ej.: CRMV-SP 12345",
				"nextVisitAt": "Fecha de retorno",
				"reason": "Motivo de la consulta",
				"reasonPlaceholder": "Ej.: vómito, chequeo, retorno",
				"notes": "Notas de la consulta",
				"weightKg": "Peso (kg)",
				"tempC": "Temperatura (°C)",
				"tempLo": "LOW/LO (sin temperatura)",
				"tempLoTooltip": "Marque cuando el termómetro no pudo medir la temperatura (valor por debajo de la escala o lectura inválida). No se registrará la temperatura.",
				"relatedVisit": "Consulta de origen",
				"relatedVisitPlaceholder": "Seleccione la consulta anterior",
				"heartRateBpm": "Frecuencia cardíaca (bpm)",
				"respRateBpm": "Frecuencia respiratoria",
				"capillaryRefillSec": "Llenado capilar (s)",
				"examSummary": "Resumen del examen",
				"findings": "Hallazgos del examen físico",
				"examRequests": "Exámenes solicitados",
				"examRequestsPlaceholder": "Seleccione paquetes y exámenes",
				"examPanelPrefix": "Paquete:",
				"otherExamTitle": "Otro examen (fuera del catálogo)",
				"otherExamHint": "Úselo cuando el examen pedido no esté en el catálogo.",
				"otherExamName": "Nombre del examen",
				"otherExamNamePlaceholder": "Ej.: Panel hepático completo",
				"otherExamNameRequired": "Indique el nombre del examen para añadirlo.",
				"otherExamKind": "Tipo (opcional)",
				"otherExamKindNone": "No informado",
				"otherExamKindPlaceholder": "Seleccione el tipo",
				"otherExamNotes": "Observación (opcional)",
				"otherExamNotesPlaceholder": "Detalles de la solicitud",
				"otherExamAdd": "Añadir otro examen",
				"freeExamTitle": "Título libre / pedido documental",
				"freeExamTitlePlaceholder": "Ej.: Pedido de exámenes de la clínica X",
				"documentOnlyRequest": "Solicitud solo documental (sin ítems estructurados)",
				"diagnosis": "Diagnóstico",
				"conditionOr": "O",
				"conditionLink": "Vincular condición existente",
				"conditionLinkPlaceholder": "Buscar condiciones de la mascota",
				"conditionDiagnosisNote": "Diagnóstico (nota)",
				"conditionDiagnosisNotePlaceholder": "Describe el diagnóstico clínico",
				"conditionNameRequired": "Indica el nombre de la condición o vincula una existente para guardar los datos de la condición clínica.",
				"proceduresDone": "Procedimientos realizados",
				"medsAdministered": "Medicamentos aplicados",
				"costTotal": "Costo total",
				"paidTotal": "Valor pagado",
				"paymentMethod": "Forma de pago",
				"successSave": "Consulta registrada con éxito.",
				"successEdit": "Consulta actualizada con éxito.",
				"errorSave": "No fue posible guardar la consulta.",
				"returnReason": "Objetivo del retorno",
				"systolicBloodPressure": "Presión arterial sistólica (mmHg)",
				"mucousMembrane": "Mucosas",
				"hydrationStatus": "Hidratación",
				"bodyConditionScore": "Condición corporal",
				"bodyConditionScale": "Escala de condición corporal",
				"historyText": "Historial relatado por el tutor",
				"reportedSigns": "Signos percibidos por el tutor",
				"painReported": "¿El tutor percibió dolor?",
				"painDetails": "Detalles del dolor relatado",
				"generalConduct": "Conducta general realizada en la consulta",
				"diagnosisName": "Hipótesis o diagnóstico",
				"diagnosisStatus": "Estado",
				"diagnosisNotes": "Observaciones",
				"newConditionName": "Crear condición con el nombre",
				"addDiagnosis": "Añadir hipótesis o diagnóstico",
				"prescriptionOriginal": "Texto original de la prescripción",
				"prescriptionSource": "Origen de la prescripción",
				"prescriptionGeneralInstructions": "Orientaciones generales",
				"prescriptionItemType": "Tipo de orientación",
				"prescriptionItemName": "Nombre",
				"doseText": "Dosis",
				"frequencyText": "Frecuencia",
				"durationText": "Duración",
				"route": "Vía",
				"prescriptionItemInstructions": "Instrucciones",
				"addPrescriptionItem": "Añadir ítem a la prescripción",
				"createTreatmentFromPrescription": "Crear tratamiento a partir de la prescripción",
				"treatmentFromPrescriptionSuccess": "Plan de tratamiento creado a partir de la prescripción.",
				"treatmentFromPrescriptionError": "No se pudo crear el tratamiento a partir de la prescripción.",
				"prescriptionUpload": "Adjuntos de la prescripción",
				"diagnosisUpload": "Informes y documentos de este diagnóstico",
				"examUpload": "Adjuntos de la solicitud de exámenes",
				"financeUpload": "Comprobantes y facturas",
				"uploadDropzone": "Arrastra archivos aquí o selecciónalos en tu dispositivo",
				"uploadBrowse": "Seleccionar archivos",
				"uploadConstraints": "PDF, JPG, PNG o WEBP de hasta 10 MB por archivo",
				"uploadAddMore": "Añadir más archivos",
				"uploadInvalidType": "Este tipo de archivo no está permitido.",
				"uploadTooLarge": "El archivo supera el límite de __MAX_SIZE__.",
				"uploadDocument": "Enviar documento (PDF o imagen)",
				"documentsEmpty": "Ningún documento adjunto a esta consulta.",
				"documentUploadSuccess": "Documento enviado.",
				"documentUploadError": "No se pudo enviar el documento.",
				"documentDeleteError": "No se pudo eliminar el documento.",
				"documentOpenError": "No se pudo abrir el documento.",
				"weightReplaceTitle": "Ya hay un peso distinto registrado ese día",
				"weightReplaceDescription": "Ya existe un peso de {existing} kg en este día, y la consulta indica {next} kg. ¿Qué desea hacer?",
				"weightReplaceConfirm": "Usar el peso de la consulta",
				"weightReplaceSkip": "Mantener el peso ya registrado",
				"documentViewImage": "Ver imagen",
				"documentOpenFile": "Abrir archivo",
				"documentDeleteSuccess": "Documento eliminado.",
				"documentZoomIn": "Acercar",
				"documentZoomOut": "Alejar",
				"documentZoomReset": "{zoom}%",
				"financeDocumentDescription": "Comprobante financiero",
				"weightDuplicateDay": "Ya existe un peso registrado ese día",
				"documentsPrescriptionLabel": "Prescripciones",
				"documentsFinanceLabel": "Comprobantes financieros",
				"documentsExamLabel": "Anexos de exámenes",
				"documentsDiagnosisLabel": "Documentos del diagnóstico",
				"documentDownloadError": "No se pudo descargar el documento."
			},
			"pain": {
				"yes": "Sí",
				"no": "No",
				"unknown": "No supo informar"
			},
			"diagnosisStatus": {
				"suspected": "Sospecha",
				"under_investigation": "En investigación",
				"probable": "Probable",
				"confirmed": "Confirmado",
				"ruled_out": "Descartado",
				"known_condition": "Condición ya conocida",
				"other": "Otro"
			},
			"prescriptionTypes": {
				"medication": "Medicamento",
				"fluid_therapy": "Fluidoterapia",
				"physiotherapy": "Fisioterapia",
				"supplement": "Suplemento",
				"diet": "Dieta",
				"home_care": "Cuidado en casa",
				"monitoring": "Monitoreo",
				"restriction": "Restricción",
				"follow_up": "Retorno",
				"other": "Otro"
			},
			"prescriptionSources": {
				"written": "Receta escrita",
				"verbal": "Orientación verbal",
				"attachment": "Anexo",
				"clinic_report": "Informe de la clínica",
				"tutor_notes": "Anotación del tutor",
				"other": "Otro"
			},
			"reportedSigns": {
				"apathy": "Apatía",
				"perceived_fever": "Fiebre percibida",
				"vomiting": "Vómito",
				"diarrhea": "Diarrea",
				"itching": "Picor",
				"loss_of_appetite": "Pérdida de apetito",
				"increased_appetite": "Aumento de apetito",
				"increased_thirst": "Aumento de sed",
				"increased_urination": "Aumento de orina",
				"difficulty_urinating": "Dificultad para orinar",
				"cough": "Tos",
				"difficulty_breathing": "Dificultad para respirar",
				"difficulty_walking": "Dificultad para caminar",
				"discharge": "Secreción",
				"bleeding": "Sangrado",
				"behavior_change": "Cambio de comportamiento",
				"pain": "Dolor",
				"other": "Otro"
			}
		},
		"glycemia": {
			"loading": "Cargando curvas glucémicas",
			"tabsAria": "Pestañas de glucemia",
			"tabs": {
				"daily": "Diaria",
				"curve": "Curva",
				"compare": "Comparación"
			},
			"close": "Cerrar",
			"ok": "Ok",
			"columns": {
				"date": "Fecha",
				"startTime": "Inicio",
				"clicks": "Dosis (UI)",
				"dose": "Dosis (UI)",
				"pointsRecorded": "Puntos",
				"notes": "Observaciones",
				"actions": "Acciones"
			},
			"pointsRecordedValue": "{count}/5",
			"doseUnit": "UI",
			"now": "ahora",
			"pointGlucosePlaceholder": "ej.: 122 o HI",
			"form": {
				"date": "Fecha",
				"startTime": "Hora inicial",
				"warnMinutes": "Alerta (min antes)",
				"warnMinutesTooltip": "Este tiempo es solo para notificaciones Web Push. En la Vista general, las mediciones próximas entran en \"Próximos\" con 1 hora fija antes del horario.",
				"warnMinutesReadonly": "Alerta Web Push (min antes)",
				"doseUi": "Dosis de insulina (UI)",
				"autoScheduleHint": "Puntos automáticos cada 3h: {t1}, {t2}, {t3}, {t4}, {t5}",
				"sessionCreateSuccess": "Curva glucémica registrada con éxito.",
				"sessionErrorSave": "No fue posible registrar la curva glucémica."
			},
			"empty": {
				"title": "Ninguna curva glucémica registrada",
				"description": "Registre una curva para seguir la respuesta a la dosis."
			},
			"actions": {
				"openAria": "Abrir medición",
				"deleteAria": "Eliminar medición"
			},
			"delete": {
				"title": "¿Eliminar medición?",
				"contentWithDate": "¿Eliminar definitivamente la medición de {date} con todos los valores?",
				"contentGeneric": "¿Eliminar definitivamente esta medición con todos los valores?",
				"confirm": "Eliminar",
				"cancel": "Cancelar",
				"success": "Medición eliminada con éxito."
			},
			"errors": {
				"load": "No se pudieron cargar las curvas glucémicas.",
				"delete": "No se pudo eliminar la medición.",
				"pointGlucoseAndTimeRequired": "Indique la glucosa y la hora para guardar el punto.",
				"pointSave": "No se pudo guardar el punto de la curva.",
				"glucoseConflictTitle": "Glucosa distinta a la misma hora",
				"glucoseConflictDescription": "Ya existe una lectura diaria de {existing} a esta hora. La curva indica {next}. ¿Qué desea hacer?",
				"glucoseConflictConfirm": "Usar el valor de la curva",
				"glucoseConflictKeep": "Mantener el valor diario"
			},
			"daily": {
				"loading": "Cargando glucemia diaria",
				"type": "Lectura",
				"newTitle": "Nueva lectura diaria",
				"newSubtitle": "Registre la glucemia del día a día",
				"editTitle": "Editar lectura diaria",
				"editSubtitle": "Actualice glucosa, hora e insulina",
				"dateLockedHint": "La fecha no se puede cambiar. Ajuste solo la hora, la glucosa y la insulina.",
				"createSuccess": "Lectura guardada con éxito.",
				"updateSuccess": "Lectura actualizada con éxito.",
				"chartName": "Glucemia",
				"chartRange": {
					"label": "Período del gráfico",
					"d7": "7 días",
					"d15": "15 días",
					"d30": "30 días",
					"custom": "Personalizado",
					"from": "Desde",
					"to": "Hasta",
					"apply": "Aplicar",
					"panelTitle": "Gráfico del período",
					"min": "Menor valor: {value} mg/dL",
					"max": "Mayor valor: {value} mg/dL",
					"minPrefix": "Menor valor",
					"maxPrefix": "Mayor valor",
					"lowestPeriod": "Período más bajo: {period}",
					"highestPeriod": "Período más alto: {period}",
					"lowestPeriodPrefix": "Período más bajo",
					"highestPeriodPrefix": "Período más alto",
					"periodDawn": "Madrugada (00h–06h)",
					"periodMorning": "Mañana (06h–12h)",
					"periodAfternoon": "Tarde (12h–18h)",
					"periodNight": "Noche (18h–00h)",
					"periodUnknown": "Datos insuficientes",
					"measurementsCountLabel": "Mediciones en el período",
					"measurementsCount": "Mediciones en el período: {count}",
					"insulinAppliedLabel": "Insulinas aplicadas",
					"rangeTooLong": "El período personalizado puede tener como máximo 6 meses. Elija un intervalo más corto.",
					"loLegend": "LO (< 20/10 mg/dL)",
					"hiLegend": "HI (> 500/600 mg/dL)",
					"loCountLabel": "Mediciones LO",
					"hiCountLabel": "Mediciones HI",
					"flagsNote": "También en el período: {flags}",
					"generatePdf": "Generar PDF",
					"pdfTitle": "Glucemia diaria",
					"pdfPeriod": "Período: {from} a {to}",
					"pdfFileName": "glucemia-diaria-{from}_{to}.pdf",
					"pdfError": "No se pudo generar el PDF.",
					"pdfColumns": {
						"date": "Fecha",
						"time": "Hora",
						"glucose": "mg/dL",
						"insulin": "Dosis de insulina",
						"notes": "Observaciones"
					}
				},
				"hiLabel": "HI (por encima del límite del medidor)",
				"loLabel": "LO (por debajo del límite del medidor)",
				"glucoseMode": {
					"value": "Valor",
					"lo": "LO",
					"hi": "HI"
				},
				"columns": {
					"time": "Hora",
					"glucose": "mg/dL",
					"insulin": "Insulina"
				},
				"insulin": {
					"yes": "Aplicada",
					"no": "No aplicada",
					"notRegistered": "No registrada",
					"notAdministered": "No apliqué insulina",
					"notAdministeredHint": "Marque si decidió no aplicar. Si deja la dosis en blanco sin marcar, se considera que la dosis no fue registrada."
				},
				"empty": {
					"title": "Sin lecturas diarias",
					"description": "Registre la glucosa del día a día para seguir el control."
				},
				"actions": {
					"deleteAria": "Eliminar lectura",
					"editAria": "Editar lectura",
					"deleteLockedTooltip": "Los registros de la curva glucémica solo puede eliminarlos un administrador"
				},
				"delete": {
					"title": "¿Eliminar lectura?",
					"content": "¿Eliminar definitivamente esta lectura diaria?",
					"success": "Lectura eliminada con éxito."
				},
				"errors": {
					"load": "No se pudo cargar la glucemia diaria.",
					"loadOne": "No se pudo cargar la lectura.",
					"save": "No se pudo guardar la lectura.",
					"delete": "No se pudo eliminar la lectura.",
					"glucoseRequired": "Indique el valor de glucosa o marque LO o HI.",
					"duplicateDateTime": "Ya existe una lectura en esta fecha y hora.",
					"duplicateSameValue": "Ya existe una lectura con el mismo valor en esta fecha y hora.",
					"glucoseConflictTitle": "Glucosa distinta a la misma hora",
					"glucoseConflictDescription": "Ya existe una lectura de {existing} a esta hora. El nuevo valor es {next}. ¿Qué desea hacer?",
					"glucoseConflictConfirm": "Usar el nuevo valor",
					"glucoseConflictKeep": "Mantener el valor existente"
				}
			},
			"compare": {
				"insufficientTitle": "Mediciones insuficientes",
				"insufficientDescription": "Se necesitan al menos 2 curvas glucémicas registradas para comparar.",
				"measurementA": "Medición A",
				"measurementB": "Medición B",
				"measurementC": "Medición C",
				"select": "Seleccione",
				"selectOptional": "Seleccione",
				"threshold": "Umbral de diferencia",
				"run": "Comparar",
				"note": "Nota",
				"formPanelTitle": "Seleccionar mediciones",
				"seriesNamed": "{label} ({date})",
				"hiDisplay": "HI (600+)",
				"notes": {
					"lower": "menor",
					"higher": "mayor",
					"equal": "igual",
					"atLeast": "Al menos {delta}"
				}
			}
		},
		"conditions": {
			"loading": "Cargando condiciones clínicas",
			"close": "Cerrar",
			"ok": "Ok",
			"columns": {
				"name": "Nombre",
				"curability": "Curabilidad",
				"status": "Estado",
				"severity": "Severidad",
				"diagnosedAt": "Diagnosticado el",
				"actions": "Acciones"
			},
			"curability": {
				"CURÁVEL": "Con cura",
				"NÃO_CURÁVEL": "Sin cura",
				"INDEFINIDO": "En evaluación"
			},
			"status": {
				"ATIVA": "Activa",
				"RESOLVIDA": "Resuelta",
				"EM_MANEJO": "En tratamiento",
				"DESCARTADA": "Descartada"
			},
			"severity": {
				"BAIXA": "Baja",
				"MODERADA": "Moderada",
				"ALTA": "Alta"
			},
			"conditionType": {
				"AGUDA": "Aguda",
				"CRÔNICA": "Crónica",
				"CONGÊNITA": "Congénita",
				"RECORRENTE": "Recurrente",
				"DESCONHECIDA": "Desconocida"
			},
			"bodySystem": {
				"ENDÓCRINO": "Endocrino",
				"RENAL": "Renal",
				"CARDÍACO": "Cardíaco",
				"RESPIRATÓRIO": "Respiratorio",
				"GASTROINTESTINAL": "Gastrointestinal",
				"NEUROLÓGICO": "Neurológico",
				"OSTEOARTICULAR": "Osteoarticular",
				"DERMATOLÓGICO": "Dermatológico",
				"HEMATOLÓGICO": "Hematológico",
				"OFTÁLMICO": "Oftálmico",
				"OUTRO": "Otro"
			},
			"controlStatus": {
				"BEM_CONTROLADA": "Bien controlada",
				"PARCIALMENTE_CONTROLADA": "Parcialmente controlada",
				"DESCOMPENSADA": "Descompensada"
			},
			"lifeRisk": {
				"BAIXO": "Bajo",
				"MODERADO": "Moderado",
				"ALTO": "Alto",
				"EMERGENCIAL": "Emergencia"
			},
			"form": {
				"name": "Nombre de la condición",
				"curability": "Curabilidad",
				"status": "Estado",
				"severity": "Severidad",
				"conditionType": "Tipo de condición",
				"bodySystem": "Sistema / órgano principal",
				"controlStatus": "Situación de control",
				"lifeRisk": "Riesgo de vida asociado",
				"symptomStartAt": "Inicio de los síntomas",
				"diagnosedAt": "Diagnosticado el",
				"resolvedAt": "Resuelta el",
				"notes": "Nota inicial",
				"followupPlan": "Plan de seguimiento",
				"successSave": "Condición registrada con éxito.",
				"successEdit": "Condición actualizada con éxito.",
				"errorSave": "No fue posible guardar la condición."
			},
			"details": {
				"tabs": {
					"aria": "Pestañas de la condición clínica",
					"general": "Información general",
					"notes": "Notas",
					"links": "Vínculos"
				},
				"infoTitle": "Información",
				"notesTitle": "Notas",
				"linksTitle": "Vínculos",
				"noteFormTitle": "Registrar nota",
				"noteFormEditTitle": "Editar nota",
				"noteContent": "Nota",
				"notePlaceholder": "Escribe una nota",
				"recordedAt": "Registrado el",
				"addNote": "Añadir nota",
				"sortLabel": "Orden",
				"sortDesc": "Más recientes primero",
				"sortAsc": "Más antiguas primero",
				"notesEmpty": "Ninguna nota",
				"notesEmptyTitle": "Ninguna nota",
				"notesEmptyDescription": "Registra la primera nota para seguir la evolución de esta condición.",
				"columns": {
					"recordedAt": "Fecha",
					"content": "Nota",
					"status": "Estado",
					"severity": "Severidad",
					"actions": "Acciones"
				},
				"labResults": "Resultados de examen",
				"labResultPlaceholder": "Seleccionar resultado",
				"treatments": "Tratamientos",
				"treatmentPlaceholder": "Seleccionar tratamiento",
				"link": "Vincular",
				"deleteNoteTitle": "¿Borrar nota?",
				"deleteNoteWithPreview": "Esta acción no se puede deshacer. Nota: \"{preview}\"",
				"deleteNoteGeneric": "Esta acción no se puede deshacer.",
				"historyNotePrefix": "Actualización clínica: {changes}",
				"historyChange": "{field}: {from} → {to}",
				"historyEmpty": "sin informar",
				"saveSuccess": "Condición actualizada con éxito.",
				"saveError": "No fue posible actualizar la condición."
			},
			"empty": {
				"title": "Ninguna condición encontrada",
				"description": "¡Este es el lugar ideal para seguir las necesidades de tu mascota!"
			},
			"actions": {
				"openAria": "Abrir condición",
				"deleteAria": "Eliminar condición"
			},
			"delete": {
				"title": "¿Eliminar condición clínica?",
				"contentWithName": "Esta acción no se puede deshacer. Condición: \"{name}\"",
				"contentGeneric": "Esta acción no se puede deshacer.",
				"confirm": "Eliminar",
				"cancel": "Cancelar",
				"success": "Condición eliminada con éxito."
			},
			"errors": {
				"load": "No se pudieron cargar las condiciones clínicas.",
				"delete": "No se pudo eliminar la condición."
			}
		},
		"exams": {
			"loading": "Cargando exámenes",
			"close": "Cerrar",
			"columns": {
				"requestedAt": "Solicitado el",
				"tests": "Exámenes solicitados",
				"clinic": "Clínica",
				"vet": "Veterinario",
				"status": "Estado",
				"progress": "Progreso",
				"actions": "Acciones"
			},
			"status": {
				"MISSING": "Pendiente",
				"PENDING": "Pendiente",
				"PARTIAL": "Parcial",
				"DONE": "Finalizado",
				"DOCUMENT": "Solo archivo"
			},
			"empty": {
				"title": "Ningún examen encontrado",
				"description": "¿Qué tal poner al día los exámenes de tu mascota?"
			},
			"actions": {
				"openAria": "Abrir examen",
				"deleteAria": "Eliminar resultado",
				"deleteDisabledTooltip": "Los resultados vinculados a consultas solo pueden modificarse o eliminarse en la consulta."
			},
			"origin": {
				"manual": "Manual",
				"visit": "Consulta"
			},
			"testsMore": "+ {count} exámenes",
			"testsMoreSingular": "+ {count} examen",
			"delete": {
				"title": "¿Eliminar resultado de examen?",
				"content": "Esta acción no se puede deshacer.",
				"confirm": "Eliminar",
				"cancel": "Cancelar",
				"success": "Resultado eliminado.",
				"error": "No se pudo eliminar el resultado."
			},
			"fallback": {
				"exam": "Examen",
				"panel": "Paquete",
				"exams": "Exámenes",
				"request": "Solicitud",
				"noRef": "Sin referencia",
				"noValue": "Sin valor",
				"inRange": "En rango",
				"low": "Bajo",
				"high": "Alto",
				"noRefShort": "Sin ref.",
				"improving": "Mejorando",
				"worsening": "Empeorando",
				"stable": "Estable",
				"noBaseline": "Sin base"
			},
			"referenceDisclaimer": "Los valores de referencia son informativos y no sustituyen la evaluación clínica ni diagnostican por sí solos.",
			"compare": {
				"filters": {
					"examLabel": "Examen / panel",
					"examPlaceholder": "Buscar examen o panel",
					"panelLabel": "Panel",
					"panelPlaceholder": "Filtrar por panel",
					"fromLabel": "Desde",
					"toLabel": "Hasta",
					"clear": "Limpiar",
					"rangeLabel": "Rango de referencia",
					"rangePlaceholder": "Todos los rangos",
					"rangeIn": "Dentro del rango",
					"rangeOut": "Fuera del rango (arriba o abajo)",
					"rangeLow": "Por debajo del rango",
					"rangeHigh": "Por encima del rango",
					"onlyRepeated": "Solo exámenes con más de una ocurrencia"
				},
				"metrics": {
					"exams": "exámenes",
					"out": "fuera",
					"inRange": "en rango",
					"last": "último",
					"missingPartial": "{count} exámenes faltando registro",
					"neverRecorded": "{count} exámenes sin registro"
				},
				"empty": {
					"title": "Ningún examen realizado",
					"description": "¡Aquí verás la comparación de los valores de los exámenes para seguir la evolución de tu mascota!"
				},
				"card": {
					"ref": "Ref:",
					"lastValue": "Último valor",
					"chartAria": "Evolución del examen",
					"noChartData": "Sin datos numéricos para el gráfico.",
					"date": "Fecha",
					"value": "Valor",
					"panel": "Panel"
				},
				"errors": {
					"load": "No se pudo cargar el comparativo."
				}
			},
			"details": {
				"tabs": {
					"aria": "Secciones del resultado de examen",
					"info": "Solicitud",
					"values": "Valores",
					"documents": "Informes"
				},
				"meta": {
					"saveError": "No se pudieron guardar los datos de la solicitud."
				},
				"visit": {
					"consultation": "Fecha de solicitud",
					"clinic": "Clínica",
					"vet": "Veterinario"
				},
				"itemsCount": "ítems",
				"columns": {
					"exam": "Examen",
					"reference": "Referencia",
					"value": "Valor",
					"performed": "Realizado",
					"resulted": "Resultado",
					"actions": "Acciones"
				},
				"edit": {
					"numeric": "Numérico",
					"text": "Texto",
					"refLow": "Mín.",
					"refHigh": "Máx.",
					"refText": "Ref. (texto)",
					"reportText": "Informe / descripción",
					"conclusion": "Conclusión",
					"reportShort": "Informe",
					"notPerformed": "No realizado",
					"valueNumPlaceholder": "Informe el valor",
					"valueTextPlaceholder": "Informe el resultado",
					"resetReference": "Restablecer referencia"
				},
				"status": {
					"label": "Estado",
					"PENDING": "Pendiente",
					"PARTIAL": "Parcial",
					"DONE": "Completado"
				},
				"panelReport": {
					"title": "Informe del panel"
				},
				"requestReport": {
					"title": "Informe / resultado de la solicitud"
				},
				"availability": {
					"NO_RESULT": "Sin resultado",
					"DOCUMENT_ONLY": "Solo documental",
					"STRUCTURED": "Estructurado",
					"HYBRID": "Híbrido"
				},
				"documentOnlyEmpty": "Resultado adjunto — sin datos estructurados para comparación.",
				"noStructuredItems": "Ningún examen estructurado en este pedido.",
				"documents": {
					"title": "Archivos adjuntos",
					"upload": "Adjuntar informe (PDF o imagen)",
					"extractPdf": "Extraer del PDF",
					"empty": "No hay archivos adjuntos en este resultado.",
					"openError": "No se pudo abrir el archivo.",
					"itemTitle": "Informe del ítem",
					"uploadHint": "Sube PDF o imagen. Si el OCR reconoce texto, sugerimos ítems estructurados; si no, el archivo queda en el informe."
				},
				"ocr": {
					"title": "Revisión de la extracción",
					"hint": "Confirma, edita o ignora cada línea antes de aplicar al pedido.",
					"empty": "No se encontraron líneas de examen en el PDF (puede no tener capa de texto).",
					"warning": "Extracción con avisos: {message}",
					"failed": "Falló la extracción: {message}",
					"suggested": "Sugerencia",
					"value": "Valor",
					"unit": "Unidad",
					"confirm": "Confirmar",
					"ignore": "Ignorar",
					"edit": "Editar",
					"apply": "Aplicar confirmados",
					"applying": "Aplicando…",
					"extracting": "Extrayendo…",
					"status": {
						"PENDING": "Pendiente",
						"CONFIRMED": "Confirmado",
						"EDITED": "Editado",
						"IGNORED": "Ignorado",
						"CUSTOM": "Custom"
					},
					"errors": {
						"extract": "No se pudo extraer el PDF.",
						"apply": "No se pudo aplicar la extracción.",
						"patch": "No se pudo actualizar la revisión."
					}
				},
				"addExam": "Agregar examen",
				"addExamHintVisit": "Para incluir nuevos exámenes vinculados a una consulta, edite la consulta.",
				"addExamPlaceholder": "Buscar examen o panel…",
				"origin": {
					"visitHint": "Origen: consulta — campos solo lectura"
				}
			},
			"errors": {
				"load": "No se pudieron cargar los exámenes."
			},
			"form": {
				"performedAt": "Fecha realizada",
				"veterinarian": "Veterinario",
				"veterinarianPlaceholder": "Seleccione el veterinario",
				"vetName": "Nombre del veterinario",
				"vetNamePlaceholder": "Nombre",
				"vetCrmv": "CRMV",
				"vetCrmvPlaceholder": "CRMV",
				"clinic": "Clínica / laboratorio",
				"clinicPlaceholder": "Seleccione la clínica",
				"clinicName": "Nombre de la clínica",
				"clinicNamePlaceholder": "Nombre",
				"notes": "Observaciones / método",
				"notesPlaceholder": "Método, laboratorio, observaciones…",
				"examRequests": "Exámenes y paneles",
				"examRequestsPlaceholder": "Seleccione exámenes o paneles",
				"valuesTitle": "Valores",
				"valuesHint": "Complete los valores ahora o después en el detalle. Cada valor se guarda individualmente.",
				"valueNum": "Valor numérico",
				"valueText": "Valor (texto)",
				"upload": "Adjuntos del resultado",
				"success": {
					"create": "Resultado de examen registrado.",
					"update": "Resultado de examen actualizado."
				},
				"errors": {
					"load": "No se pudo cargar el formulario de exámenes.",
					"save": "No se pudo guardar el resultado de examen.",
					"examsOrUpload": "Seleccione al menos un examen/panel o adjunte un archivo."
				}
			},
			"filters": {
				"statusLabel": "Estado",
				"statusPlaceholder": "Filtrar por estado",
				"originLabel": "Origen",
				"originPlaceholder": "Manual o consulta",
				"examLabel": "Examen / panel",
				"examPlaceholder": "Buscar por examen, panel o ítem (ej.: Monocitos)"
			}
		},
		"petAccess": {
			"title": "Acceso de veterinarios",
			"loading": "Cargando accesos",
			"fallbackInvite": "Invitación",
			"invite": {
				"title": "Invitar veterinario",
				"nameLabel": "Nombre",
				"namePlaceholder": "Ej: Dra. Ana",
				"emailLabel": "Correo",
				"emailPlaceholder": "email@ejemplo.com",
				"submit": "Enviar invitación",
				"hint": "El veterinario recibirá un enlace para aceptar el acceso.",
				"sent": "Invitación enviada.",
				"resent": "Invitación reenviada."
			},
			"filters": {
				"searchLabel": "Buscar",
				"searchPlaceholder": "Filtrar por nombre o correo",
				"kindLabel": "Tipo",
				"kindPlaceholder": "Cuál",
				"kindAccess": "Accesos",
				"kindInvite": "Invitaciones",
				"kindClearAria": "Limpiar tipo",
				"statusLabel": "Estado",
				"statusPlaceholder": "Estado",
				"statusClearAria": "Limpiar estado",
				"onlyActiveAccess": "Mostrar solo accesos activos"
			},
			"status": {
				"active": "Activo",
				"blocked": "Bloqueado",
				"pending": "Pendiente",
				"expired": "Expirado",
				"accepted": "Aceptado",
				"revoked": "Cancelado",
				"vetRejected": "Rechazado por el veterinario"
			},
			"columns": {
				"name": "Nombre",
				"kind": "Tipo",
				"email": "Correo",
				"status": "Estado",
				"actions": "Acciones"
			},
			"empty": {
				"title": "Ningún veterinario o invitación encontrado",
				"description": "Invita a un veterinario para seguir la salud de tu mascota."
			},
			"noResults": {
				"title": "Ningún resultado encontrado",
				"description": "Intenta ajustar los filtros para encontrar lo que buscas."
			},
			"actions": {
				"activateAria": "Activar acceso",
				"blockAria": "Bloquear acceso",
				"unblockAria": "Desbloquear acceso",
				"removeAria": "Eliminar acceso",
				"cancelInviteAria": "Cancelar invitación",
				"resendInviteAria": "Reenviar invitación"
			},
			"modal": {
				"cancel": "Cancelar"
			},
			"revokeInvite": {
				"title": "¿Cancelar invitación?",
				"contentWithEmail": "¿Seguro que deseas cancelar la invitación para \"{email}\"?",
				"contentGeneric": "¿Seguro que deseas cancelar esta invitación?",
				"confirm": "Cancelar invitación",
				"success": "Invitación cancelada."
			},
			"removeAccess": {
				"title": "¿Eliminar acceso?",
				"contentWithName": "¿Seguro que deseas eliminar el acceso de \"{name}\"?",
				"contentGeneric": "¿Seguro que deseas eliminar este acceso?",
				"confirm": "Eliminar",
				"success": "Acceso eliminado."
			},
			"errors": {
				"load": "No se pudieron cargar los accesos.",
				"invite": "No se pudo enviar la invitación.",
				"inviteAlreadySent": "Esta mascota ya tiene una invitación pendiente para este correo.",
				"alreadyHasAccess": "Este correo ya tiene acceso a esta mascota.",
				"resend": "No se pudo reenviar la invitación.",
				"updateStatus": "No se pudo actualizar el acceso.",
				"revokeInvite": "No se pudo cancelar la invitación.",
				"removeAccess": "No se pudo eliminar el acceso."
			}
		},
		"settings": {
			"shared": {
				"species": {
					"dog": "Perro",
					"cat": "Gato",
					"dog_cat": "Perro y Gato",
					"other": "Otro"
				},
				"sex": {
					"male": "Macho",
					"female": "Hembra",
					"notDeclared": "No informado"
				},
				"examKinds": {
					"BLOOD": "Sangre",
					"URINE": "Orina",
					"FECES": "Heces",
					"IMAGE": "Imagen",
					"CYTOLOGY": "Citología",
					"HISTOPATHOLOGY": "Histopatología",
					"MICROBIOLOGY": "Microbiología",
					"RAPID_TEST": "Prueba rápida",
					"GENETIC": "Genético",
					"CARDIOLOGY": "Cardiológico",
					"OTHER": "Otro"
				},
				"fasting": {
					"NO": "No",
					"YES": "Sí",
					"PREFERRED": "Preferiblemente sí",
					"NOT_APPLICABLE": "No aplicable",
					"VARIABLE": "Variable",
					"NAO": "No",
					"SIM": "Sí",
					"PREFERENCIALMENTE_SIM": "Preferiblemente sí"
				},
				"labSpecies": {
					"DOG": "Perro",
					"CAT": "Gato"
				},
				"labTestStatuses": {
					"DRAFT": "Borrador",
					"ACTIVE": "Activo",
					"INACTIVE": "Inactivo",
					"DEPRECATED": "Obsoleto"
				},
				"resultTypes": {
					"NUMERIC": "Numérico",
					"QUALITATIVE": "Cualitativo",
					"ORDINAL": "Ordinal",
					"BOOLEAN": "Booleano",
					"TEXT": "Texto",
					"REPORT": "Informe",
					"COMPOSITE": "Compuesto",
					"UNSPECIFIED": "No especificado"
				}
			},
			"vaccineTypes": {
				"close": "Cerrar",
				"loading": "Cargando catálogo de vacunas",
				"tabs": {
					"aria": "Catálogo de vacunas",
					"kinds": "Tipos",
					"brands": "Marcas",
					"products": "Productos",
					"others": "Otros"
				},
				"yes": "Sí",
				"no": "No",
				"active": "Activo",
				"inactive": "Inactivo",
				"filters": {
					"showDeleted": "Mostrar eliminados"
				},
				"actions": {
					"delete": "Eliminar",
					"deleteAria": "Eliminar elemento del catálogo",
					"restore": "Restaurar",
					"restoreAria": "Restaurar elemento del catálogo",
					"cancel": "Cancelar"
				},
				"delete": {
					"title": "¿Eliminar elemento del catálogo?",
					"content": "Esto marcará \"{name}\" como eliminado. Ya no aparecerá en las listas predeterminadas.",
					"success": "Elemento eliminado."
				},
				"restore": {
					"title": "¿Restaurar elemento del catálogo?",
					"content": "Esto restaurará \"{name}\" en las listas predeterminadas.",
					"success": "Elemento restaurado."
				},
				"errors": {
					"delete": "No se pudo eliminar el elemento.",
					"restore": "No se pudo restaurar el elemento."
				},
				"kinds": {
					"loading": "Cargando tipos",
					"form": {
						"createTitle": "Registrar tipo de vacuna",
						"editTitle": "Editar tipo de vacuna",
						"codeLabel": "Código",
						"codePlaceholder": "Ej.: RABIES",
						"nameLabel": "Nombre predeterminado",
						"boosterGroupLabel": "Grupo de refuerzo",
						"boosterGroupPlaceholder": "Seleccione el grupo",
						"boosterGroupOther": "Otro (informar código)",
						"boosterGroupOtherCodeLabel": "Código del grupo",
						"boosterGroupOtherCodePlaceholder": "Ej.: canine-polyvalent",
						"speciesLabel": "Especies",
						"diseasesLabel": "Enfermedades cubiertas",
						"diseasesPlaceholder": "Seleccione las enfermedades",
						"diseasesEmpty": "Ninguna enfermedad encontrada",
						"isOtherLabel": "Tipo \"Otra\"",
						"alertsEnabledLabel": "Generar alertas de refuerzo",
						"activeLabel": "Activo",
						"descriptionLabel": "Descripción",
						"descriptionPlaceholder": "Escribe la descripción",
						"save": "Guardar",
						"cancel": "Cancelar"
					},
					"filters": {
						"nameLabel": "Búsqueda",
						"namePlaceholder": "Código o nombre",
						"speciesLabel": "Especie",
						"speciesPlaceholder": "Especie",
						"speciesClearAria": "Limpiar especie"
					},
					"columns": {
						"code": "Código",
						"name": "Nombre",
						"boosterGroup": "Grupo de refuerzo",
						"species": "Especies",
						"diseases": "Enfermedades",
						"isOther": "Otra",
						"active": "Activo",
						"actions": "Acciones"
					},
					"empty": {
						"title": "Ningún tipo registrado",
						"description": "Registre los tipos de vacuna del sistema."
					},
					"noResults": {
						"title": "Ningún tipo encontrado",
						"description": "Intenta ajustar los filtros para encontrar lo que buscas."
					},
					"actions": {
						"editAria": "Editar tipo"
					},
					"errors": {
						"load": "No se pudieron cargar los tipos de vacuna.",
						"save": "No se pudo guardar el tipo de vacuna.",
						"speciesRequired": "Seleccione al menos una especie.",
						"boosterGroupRequired": "Informe el grupo de refuerzo."
					},
					"boosterGroups": {
						"canine-polyvalent": "Polivalente canina",
						"feline-polyvalent": "Polivalente felina"
					}
				},
				"brands": {
					"loading": "Cargando marcas",
					"form": {
						"createTitle": "Registrar marca",
						"editTitle": "Editar marca",
						"nameLabel": "Nombre",
						"activeLabel": "Activa",
						"save": "Guardar",
						"cancel": "Cancelar"
					},
					"filters": {
						"nameLabel": "Búsqueda",
						"namePlaceholder": "Nombre de la marca"
					},
					"columns": {
						"name": "Nombre",
						"active": "Activa",
						"actions": "Acciones"
					},
					"empty": {
						"title": "Ninguna marca registrada",
						"description": "Registre las marcas comerciales de vacunas."
					},
					"noResults": {
						"title": "Ninguna marca encontrada",
						"description": "Intenta ajustar los filtros para encontrar lo que buscas."
					},
					"actions": {
						"editAria": "Editar marca"
					},
					"errors": {
						"load": "No se pudieron cargar las marcas.",
						"save": "No se pudo guardar la marca."
					}
				},
				"products": {
					"loading": "Cargando productos",
					"form": {
						"createTitle": "Registrar producto",
						"editTitle": "Editar producto",
						"kindLabel": "Tipo",
						"kindPlaceholder": "Seleccione el tipo",
						"brandLabel": "Marca",
						"brandPlaceholder": "Seleccione la marca",
						"nameLabel": "Nombre comercial",
						"speciesLabel": "Especies",
						"isOtherLabel": "Producto \"Otro\"",
						"activeLabel": "Activo",
						"notesLabel": "Observaciones",
						"notesPlaceholder": "Escribe observaciones",
						"save": "Guardar",
						"cancel": "Cancelar"
					},
					"filters": {
						"nameLabel": "Búsqueda",
						"namePlaceholder": "Nombre comercial",
						"kindLabel": "Tipo",
						"kindPlaceholder": "Tipo",
						"kindClearAria": "Limpiar tipo",
						"speciesLabel": "Especie",
						"speciesPlaceholder": "Especie",
						"speciesClearAria": "Limpiar especie"
					},
					"columns": {
						"name": "Nombre comercial",
						"kind": "Tipo",
						"brand": "Marca",
						"species": "Especies",
						"isOther": "Otro",
						"active": "Activo",
						"actions": "Acciones"
					},
					"empty": {
						"title": "Ningún producto registrado",
						"description": "Registre los productos comerciales de vacunas."
					},
					"noResults": {
						"title": "Ningún producto encontrado",
						"description": "Intenta ajustar los filtros para encontrar lo que buscas."
					},
					"actions": {
						"editAria": "Editar producto"
					},
					"errors": {
						"load": "No se pudieron cargar los productos.",
						"save": "No se pudo guardar el producto.",
						"speciesRequired": "Seleccione al menos una especie."
					}
				},
				"others": {
					"loading": "Cargando cola de otros",
					"filters": {
						"statusLabel": "Estado"
					},
					"status": {
						"open": "Abiertos",
						"promoted": "Promovidos",
						"dismissed": "Descartados",
						"all": "Todos"
					},
					"columns": {
						"type": "Tipo",
						"rawText": "Texto",
						"applicationCount": "Ocurrencias",
						"actions": "Acciones"
					},
					"typeKind": "Tipo de vacuna",
					"typeProduct": "Producto",
					"actions": {
						"promote": "Promover",
						"dismiss": "Descartar"
					},
					"form": {
						"codeLabel": "Código",
						"nameLabel": "Nombre predeterminado",
						"commercialNameLabel": "Nombre comercial",
						"kindLabel": "Tipo de vacuna",
						"kindPlaceholder": "Seleccione el tipo",
						"speciesLabel": "Especies",
						"cancel": "Cancelar",
						"confirmPromote": "Confirmar"
					},
					"empty": {
						"title": "Ningún elemento en la cola",
						"description": "Los textos libres de vacuna aparecerán aquí para revisión."
					},
					"noResults": {
						"title": "Ningún elemento encontrado",
						"description": "Intenta ajustar el filtro de estado."
					},
					"errors": {
						"load": "No se pudo cargar la cola de otros.",
						"dismiss": "No se pudo descartar el elemento.",
						"promote": "No se pudo promover el elemento.",
						"speciesRequired": "Seleccione al menos una especie.",
						"kindRequired": "Seleccione el tipo de vacuna."
					}
				}
			},
			"diseases": {
				"close": "Cerrar",
				"loading": "Cargando enfermedades",
				"form": {
					"createTitle": "Registrar enfermedad",
					"editTitle": "Editar enfermedad",
					"codeLabel": "Código",
					"codePlaceholder": "Ej.: RABIES",
					"nameLabel": "Nombre predeterminado",
					"activeLabel": "Activa",
					"save": "Guardar",
					"cancel": "Cancelar"
				},
				"filters": {
					"nameLabel": "Búsqueda",
					"namePlaceholder": "Código o nombre",
					"showDeleted": "Mostrar eliminadas"
				},
				"columns": {
					"code": "Código",
					"name": "Nombre",
					"active": "Activa",
					"actions": "Acciones"
				},
				"empty": {
					"title": "Ninguna enfermedad registrada",
					"description": "Registre enfermedades para vincular a vacunas, diagnósticos y condiciones."
				},
				"noResults": {
					"title": "Ninguna enfermedad encontrada",
					"description": "Pruebe ajustar los filtros para encontrar lo que busca."
				},
				"actions": {
					"editAria": "Editar enfermedad",
					"delete": "Eliminar",
					"deleteAria": "Eliminar enfermedad",
					"restore": "Restaurar",
					"restoreAria": "Restaurar enfermedad",
					"cancel": "Cancelar"
				},
				"delete": {
					"title": "¿Eliminar enfermedad?",
					"content": "Esto marcará \"{name}\" como eliminada.",
					"success": "Enfermedad eliminada."
				},
				"restore": {
					"title": "¿Restaurar enfermedad?",
					"content": "Esto restaurará \"{name}\".",
					"success": "Enfermedad restaurada."
				},
				"errors": {
					"load": "No se pudieron cargar las enfermedades.",
					"save": "No se pudo guardar la enfermedad.",
					"delete": "No se pudo eliminar la enfermedad.",
					"restore": "No se pudo restaurar la enfermedad."
				}
			},
			"breeds": {
				"title": "Razas y pelaje",
				"subtitle": "Consulta las razas, gestiona colores de pelaje y revisa textos libres marcados como \"Otro\"",
				"close": "Cerrar alerta",
				"tabs": {
					"aria": "Secciones de razas",
					"catalog": "Razas",
					"reference": "Pelaje",
					"others": "Otros"
				},
				"catalog": {
					"loading": "Cargando razas",
					"filters": {
						"species": "Especie",
						"search": "Búsqueda",
						"searchPlaceholder": "Nombre o código"
					},
					"columns": {
						"code": "Código",
						"name": "Nombre",
						"group": "Grupo"
					},
					"empty": {
						"title": "No se encontraron razas",
						"description": "Ajusta los filtros o selecciona otra especie."
					},
					"noResults": {
						"title": "Sin resultados",
						"description": "Ninguna raza coincide con los filtros actuales."
					},
					"errors": {
						"load": "No se pudieron cargar las razas.",
						"save": "No se pudo guardar la raza.",
						"codeExists": "Ya existe una raza con este código para la especie."
					},
					"saveSuccess": "Raza registrada correctamente.",
					"form": {
						"createTitle": "Registrar raza",
						"speciesLabel": "Especie",
						"codeLabel": "Código",
						"codePlaceholder": "ej.: LABRADOR",
						"nameLabel": "Nombre",
						"namePlaceholder": "Nombre visible",
						"save": "Guardar"
					}
				},
				"colors": {
					"loading": "Cargando colores",
					"filterTipo": "colores",
					"saveSuccess": "Color guardado correctamente.",
					"deleteSuccess": "Color eliminado correctamente.",
					"restoreSuccess": "Color restaurado correctamente.",
					"filters": {
						"search": "Búsqueda",
						"searchPlaceholder": "Nombre o código",
						"showDeleted": "Mostrar eliminados"
					},
					"form": {
						"createTitle": "Registrar nuevo color",
						"editTitle": "Editar color",
						"codeLabel": "Código",
						"codePlaceholder": "ej.: merle",
						"nameLabel": "Nombre",
						"namePlaceholder": "Nombre visible",
						"sortOrderLabel": "Orden",
						"activeLabel": "Activo",
						"save": "Guardar",
						"cancel": "Cancelar"
					},
					"columns": {
						"code": "Código",
						"name": "Nombre",
						"sortOrder": "Orden",
						"active": "Activo",
						"actions": "Acciones"
					},
					"actions": {
						"editAria": "Editar color",
						"deleteAria": "Eliminar color",
						"restoreAria": "Restaurar color",
						"delete": "Eliminar",
						"restore": "Restaurar",
						"cancel": "Cancelar"
					},
					"delete": {
						"title": "Eliminar color",
						"content": "¿Eliminar el color \"{{name}}\"? Las mascotas que ya lo usan mantienen el valor guardado."
					},
					"restore": {
						"title": "Restaurar color",
						"content": "¿Restaurar el color \"{{name}}\"?"
					},
					"empty": {
						"title": "No hay colores",
						"description": "Registra el primer color de pelaje."
					},
					"noResults": {
						"title": "Sin resultados",
						"description": "Ningún color coincide con los filtros actuales."
					},
					"errors": {
						"load": "No se pudieron cargar los colores.",
						"save": "No se pudo guardar el color.",
						"delete": "No se pudo eliminar el color.",
						"restore": "No se pudo restaurar el color."
					}
				},
				"others": {
					"loading": "Cargando cola de revisión",
					"filters": {
						"species": "Especie",
						"status": "Estado",
						"allSpecies": "Todas las especies"
					},
					"columns": {
						"text": "Texto informado",
						"species": "Especie",
						"pets": "Mascotas",
						"status": "Estado",
						"actions": "Acciones"
					},
					"status": {
						"open": "Abierto",
						"promoted": "Promovido",
						"dismissed": "Descartado",
						"all": "Todos"
					},
					"actions": {
						"promote": "Promover",
						"dismiss": "Descartar"
					},
					"promote": {
						"code": "Código",
						"name": "Nombre",
						"species": "Especie",
						"create": "Crear raza",
						"linkExisting": "Vincular a raza existente",
						"link": "Vincular",
						"cancel": "Cancelar"
					},
					"empty": {
						"title": "Cola vacía",
						"description": "Los textos libres marcados como \"Otro\" aparecerán aquí para revisión."
					},
					"noResults": {
						"title": "Sin resultados",
						"description": "Ningún elemento coincide con los filtros actuales."
					},
					"promoteSuccess": "Raza promovida correctamente.",
					"dismissSuccess": "Elemento descartado.",
					"errors": {
						"load": "No se pudo cargar la cola de revisión.",
						"promote": "No se pudo promover este elemento.",
						"dismiss": "No se pudo descartar este elemento."
					}
				}
			},
			"examTypes": {
				"close": "Cerrar",
				"loading": "Cargando tipos de examen",
				"disclaimer": "Los valores de referencia son informativos y no sustituyen la evaluación clínica ni diagnostican por sí solos.",
				"form": {
					"createTitle": "Registrar tipo de examen",
					"editTitle": "Editar tipo de examen",
					"nameLabel": "Nombre conocido",
					"namePlaceholder": "Ej.: Glucosa, SDMA, ALT",
					"officialNameLabel": "Nombre oficial",
					"officialNamePlaceholder": "Ej.: Glucosa sérica",
					"codeLabel": "Código",
					"codePlaceholder": "Ej.: GLU-SER",
					"categoryLabel": "Categoría (texto legado)",
					"categoryIdLabel": "Categoría",
					"categoryIdPlaceholder": "Seleccione la categoría",
					"subcategoryIdLabel": "Subcategoría",
					"subcategoryIdPlaceholder": "Seleccione la subcategoría",
					"speciesLabel": "Especie",
					"speciesPlaceholder": "Especie",
					"speciesCodesLabel": "Especies aplicables",
					"speciesRequiredError": "Seleccione al menos una especie.",
					"examKindLabel": "Tipo de examen",
					"examKindPlaceholder": "Tipo de examen",
					"statusLabel": "Estado",
					"resultTypeLabel": "Tipo de resultado",
					"aliasesLabel": "Alias / sinónimos",
					"aliasesPlaceholder": "Separe por coma",
					"tagsLabel": "Etiquetas",
					"tagsPlaceholder": "Separe por coma",
					"resultOptionsLabel": "Opciones cualitativas",
					"resultOptionsPlaceholder": "Ej.: Negativo, Positivo, Indeterminado",
					"replacementLabel": "Examen sustituto (obsoleto)",
					"replacementPlaceholder": "Seleccione el examen canónico",
					"unitLabel": "Unidad",
					"refDogTitle": "Referencia — perro",
					"refCatTitle": "Referencia — gato",
					"refLowLabel": "Mínima",
					"refHighLabel": "Máxima",
					"refTextLabel": "Texto de referencia",
					"refNotesLabel": "Notas de la referencia",
					"fastingRequiredLabel": "¿Requiere ayuno?",
					"fastingRequiredPlaceholder": "Ayuno",
					"fastingTimeLabel": "Tiempo de ayuno",
					"fastingTimePlaceholder": "Ej.: 8 a 12 horas",
					"fastingMinLabel": "Ayuno mínimo (min)",
					"fastingMaxLabel": "Ayuno máximo (min)",
					"descriptionLabel": "Descripción",
					"descriptionPlaceholder": "Descripción técnica del examen",
					"preparationInformationLabel": "Información de preparación",
					"preparationInformationPlaceholder": "Orientaciones de preparación del paciente",
					"additionalInfoLabel": "Información del catálogo",
					"additionalInfoPlaceholder": "Orientaciones y observaciones del catálogo...",
					"reviewRequiredLabel": "Requiere revisión",
					"routineLabel": "Rutina",
					"sortOrderLabel": "Orden de visualización",
					"save": "Guardar",
					"cancel": "Cancelar",
					"softDelete": "Eliminar (desactivar)",
					"deactivate": "Eliminar (desactivar)",
					"saveSuccess": "Tipo de examen guardado con éxito.",
					"updateSuccess": "Tipo de examen actualizado con éxito.",
					"softDeleteSuccess": "Tipo de examen eliminado (desactivado).",
					"deactivateSuccess": "Tipo de examen eliminado (desactivado)."
				},
				"filters": {
					"nameLabel": "Nombre del examen",
					"namePlaceholder": "Nombre (conocido u oficial)",
					"speciesLabel": "Especie",
					"speciesPlaceholder": "Especie",
					"speciesClearAria": "Limpiar especie",
					"examKindLabel": "Tipo de examen",
					"statusLabel": "Estado",
					"includeInactive": "Incluir inactivos",
					"includeDeprecated": "Incluir obsoletos"
				},
				"columns": {
					"name": "Nombre",
					"officialName": "Nombre oficial",
					"status": "Estado",
					"species": "Especie",
					"examKind": "Tipo de examen",
					"unit": "Unidad",
					"reference": "Referencia",
					"category": "Categoría",
					"additionalInfo": "Info adicional",
					"actions": "Acciones"
				},
				"empty": {
					"title": "Ningún tipo de examen registrado",
					"description": "Registre tipos de examen para que estén disponibles en el sistema."
				},
				"noResults": {
					"title": "Ningún tipo de examen encontrado",
					"description": "Intente ajustar los filtros."
				},
				"actions": {
					"editAria": "Editar tipo de examen",
					"duplicateAria": "Duplicar tipo de examen",
					"softDeleteAria": "Eliminar tipo de examen"
				},
				"errors": {
					"load": "No se pudieron cargar los tipos de examen.",
					"save": "No se pudo guardar el tipo de examen.",
					"softDelete": "No se pudo eliminar el tipo de examen.",
					"deactivate": "No se pudo eliminar el tipo de examen."
				}
			},
			"examPanels": {
				"close": "Cerrar",
				"loading": "Cargando paquetes de examen",
				"form": {
					"createTitle": "Registrar paquete de examen",
					"editTitle": "Editar paquete de examen",
					"nameLabel": "Nombre del paquete",
					"officialNameLabel": "Nombre oficial",
					"officialNamePlaceholder": "Nombre oficial del paquete",
					"codeLabel": "Código",
					"codePlaceholder": "Ej.: PANEL-BIOQ",
					"statusLabel": "Estado",
					"speciesLabel": "Especie (legado)",
					"speciesPlaceholder": "Especie",
					"speciesCodesLabel": "Especies aplicables",
					"speciesRequiredError": "Seleccione al menos una especie.",
					"examKindLabel": "Tipo de examen",
					"examKindPlaceholder": "Tipo de examen",
					"categoryIdLabel": "Categoría",
					"categoryIdPlaceholder": "Seleccione la categoría",
					"fastingRequiredLabel": "¿Requiere ayuno?",
					"fastingRequiredPlaceholder": "Ayuno",
					"fastingTimeLabel": "Tiempo de ayuno",
					"fastingTimePlaceholder": "Ej.: 8 a 12 horas",
					"fastingMinLabel": "Ayuno mínimo (min)",
					"fastingMaxLabel": "Ayuno máximo (min)",
					"descriptionLabel": "Descripción",
					"descriptionPlaceholder": "Descripción del paquete",
					"reviewRequiredLabel": "Requiere revisión",
					"sortOrderLabel": "Orden de visualización",
					"itemsTitle": "Exámenes que forman parte del paquete",
					"itemTypeLabel": "Tipo de examen",
					"itemTypePlaceholder": "Seleccionar tipo de examen",
					"itemTypeEmpty": "Ningún tipo de examen disponible",
					"itemRequiredLabel": "Obligatorio",
					"itemDefaultLabel": "Seleccionado por defecto",
					"addItem": "Añadir al paquete",
					"itemsEmpty": "Ningún examen añadido al paquete.",
					"tagRequired": "Obligatorio",
					"tagDefault": "Seleccionado por defecto",
					"saveSuccess": "Paquete de examen guardado con éxito.",
					"updateSuccess": "Paquete de examen actualizado con éxito.",
					"softDelete": "Eliminar (desactivar)",
					"softDeleteSuccess": "Paquete de examen eliminado (desactivado).",
					"removeItem": "Eliminar",
					"moveItemUp": "Mover examen hacia arriba",
					"moveItemDown": "Mover examen hacia abajo",
					"save": "Guardar",
					"cancel": "Cancelar"
				},
				"filters": {
					"nameLabel": "Nombre del paquete",
					"namePlaceholder": "Nombre del paquete",
					"speciesLabel": "Especie",
					"speciesPlaceholder": "Especie",
					"speciesClearAria": "Limpiar especie",
					"examKindLabel": "Tipo de examen",
					"examKindPlaceholder": "Tipo de examen",
					"examKindClearAria": "Limpiar tipo de examen",
					"statusLabel": "Estado",
					"includeInactive": "Incluir inactivos",
					"includeDeprecated": "Incluir obsoletos"
				},
				"columns": {
					"name": "Nombre",
					"species": "Especie",
					"examKind": "Tipo de examen",
					"status": "Estado",
					"itemsCount": "Cant. de exámenes",
					"description": "Descripción",
					"actions": "Acciones"
				},
				"empty": {
					"title": "Ningún paquete de examen registrado",
					"description": "Registre paquetes para que los exámenes estén disponibles en el sistema."
				},
				"noResults": {
					"title": "Ningún paquete encontrado",
					"description": "Intente ajustar los filtros."
				},
				"actions": {
					"editAria": "Editar paquete de examen",
					"softDeleteAria": "Eliminar paquete de examen"
				},
				"errors": {
					"load": "No se pudieron cargar los paquetes de examen.",
					"save": "No se pudo guardar el paquete de examen.",
					"softDelete": "No se pudo eliminar el paquete de examen."
				}
			},
			"exams": {
				"tabs": {
					"aria": "Secciones de administración de exámenes",
					"catalog": "Catálogo",
					"panels": "Paneles",
					"audit": "Auditoría",
					"imports": "Importaciones",
					"auditComingSoon": "La auditoría de exámenes estará disponible en una etapa posterior.",
					"importsComingSoon": "Las importaciones de hoja/PDF estarán disponibles en etapas futuras."
				},
				"audit": {
					"disclaimer": "Revise exámenes pedidos como “Otro”. Crear o fusionar promueve al catálogo oficial y religa solicitudes; rechazar mantiene el texto original sin promover.",
					"loading": "Cargando cola de auditoría",
					"createSuccess": "Tipo oficial creado y entrada resuelta.",
					"mergeSuccess": "Entrada fusionada al tipo oficial.",
					"rejectSuccess": "Entrada rechazada.",
					"reopenSuccess": "Entrada reabierta para revisión.",
					"mergeTargetAria": "Tipo oficial para fusionar",
					"mergeTargetPlaceholder": "Buscar examen oficial…",
					"filters": {
						"status": "Estado",
						"q": "Búsqueda",
						"qPlaceholder": "Nombre original"
					},
					"columns": {
						"name": "Nombre original",
						"status": "Estado",
						"kind": "Tipo sugerido",
						"official": "Oficial",
						"updatedAt": "Actualizado",
						"actions": "Acciones"
					},
					"actions": {
						"create": "Crear oficial",
						"merge": "Fusionar",
						"reject": "Rechazar",
						"reopen": "Reabrir"
					},
					"status": {
						"pending": "Pendiente",
						"created": "Creado",
						"merged": "Fusionado",
						"rejected": "Rechazado",
						"all": "Todos"
					},
					"empty": {
						"title": "Sin entradas",
						"description": "Cuando los tutores pidan exámenes fuera del catálogo, aparecerán aquí."
					},
					"errors": {
						"load": "No se pudo cargar la auditoría.",
						"create": "No se pudo crear el tipo oficial.",
						"merge": "No se pudo fusionar la entrada.",
						"mergeTarget": "Indique el ID del tipo oficial para fusionar.",
						"reject": "No se pudo rechazar la entrada.",
						"reopen": "No se pudo reabrir la entrada."
					},
					"mergeTargetEmpty": "Ningún examen encontrado"
				},
				"imports": {
					"disclaimer": "Importe el catálogo en CSV o JSON, revise las clasificaciones y aplique acciones por fila. La plantilla v1 no incluye XLSX.",
					"loading": "Cargando importaciones",
					"uploadSuccess": "Archivo enviado y clasificado correctamente.",
					"actionsSaved": "Acciones de las filas guardadas.",
					"applySuccess": "Importación aplicada correctamente.",
					"emptyRows": "No hay filas en esta importación.",
					"columns": {
						"filename": "Archivo",
						"status": "Estado",
						"totals": "Resumen",
						"createdAt": "Creado el",
						"actions": "Acciones"
					},
					"actions": {
						"downloadTemplate": "Descargar plantilla",
						"upload": "Subir archivo",
						"saveRows": "Guardar acciones",
						"apply": "Aplicar importación",
						"openAria": "Abrir detalle de la importación",
						"create": "Crear",
						"update": "Actualizar",
						"ignore": "Ignorar",
						"link": "Vincular"
					},
					"status": {
						"readyForReview": "Listo para revisión",
						"processing": "Procesando",
						"applied": "Aplicado",
						"failed": "Falló",
						"cancelled": "Cancelado"
					},
					"classification": {
						"new": "Nuevo",
						"identical": "Idéntico",
						"different": "Diferente",
						"possibleDuplicate": "Posible duplicado",
						"invalid": "Inválido"
					},
					"empty": {
						"title": "Sin importaciones",
						"description": "Descargue la plantilla y suba un CSV o JSON para empezar."
					},
					"errors": {
						"load": "No se pudieron cargar las importaciones.",
						"template": "No se pudo descargar la plantilla.",
						"upload": "No se pudo subir el archivo.",
						"detail": "No se pudo abrir el detalle de la importación.",
						"saveRows": "No se pudieron guardar las acciones de las filas.",
						"apply": "No se pudo aplicar la importación."
					},
					"hints": {
						"create": "Sugerencia: crear en el catálogo",
						"update": "Sugerencia: actualizar el examen correspondiente",
						"link": "Sugerencia: vincular / revisar duplicado",
						"ignore": "Sugerencia: ignorar"
					},
					"compare": {
						"matched": "Coincide con",
						"field": "Campo",
						"incoming": "Importado",
						"catalog": "Catálogo actual",
						"fields": {
							"code": "Código",
							"name": "Nombre",
							"officialName": "Nombre oficial",
							"examKind": "Tipo",
							"status": "Estado",
							"resultType": "Tipo de resultado",
							"unit": "Unidad",
							"refLow": "Ref. mínima",
							"refHigh": "Ref. máxima",
							"category": "Categoría",
							"fastingRequirement": "Ayuno",
							"description": "Descripción",
							"additionalInfo": "Info adicional",
							"species": "Especies"
						}
					},
					"actionHelp": {
						"createHelp": "Crea un nuevo examen en el catálogo con los datos Importados.",
						"updateHelp": "Sustituye el examen correspondiente del catálogo por los valores Importados.",
						"ignoreHelp": "No cambia el catálogo; la fila importada se descarta.",
						"linkHelp": "Aún no implementado de verdad (hoy se comporta como Ignorar). Indica cómo debe funcionar."
					}
				}
			},
			"systemUsers": {
				"loading": "Cargando usuarios",
				"filters": {
					"searchLabel": "Buscar",
					"searchPlaceholder": "Nombre, correo, teléfono",
					"roleLabel": "Tipo",
					"rolePlaceholder": "Todos",
					"roleClearAria": "Limpiar tipo",
					"showDeleted": "Mostrar eliminados"
				},
				"roles": {
					"user": "Tutor",
					"vet": "Veterinario",
					"master": "Master"
				},
				"status": {
					"active": "Activo",
					"pendingVerification": "Pendiente de verificación",
					"blocked": "Bloqueado",
					"deleted": "Eliminado"
				},
				"columns": {
					"name": "Nombre",
					"email": "Correo",
					"role": "Tipo",
					"pets": "Mascotas",
					"status": "Estado",
					"createdAt": "Creado",
					"actions": "Acciones"
				},
				"empty": {
					"title": "Ningún usuario registrado",
					"description": "¡Pronto tendremos usuarios en el sistema! :)"
				},
				"noResults": {
					"title": "Ningún usuario encontrado",
					"description": "Intenta ajustar los filtros para encontrar lo que buscas."
				},
				"actions": {
					"restoreAria": "Restaurar usuario",
					"deleteForeverAria": "Eliminar definitivamente",
					"blockAria": "Bloquear usuario",
					"unblockAria": "Desbloquear usuario",
					"deleteAria": "Eliminar usuario",
					"resendVerificationAria": "Reenviar correo de verificación"
				},
				"modal": {
					"cancel": "Cancelar"
				},
				"delete": {
					"title": "Eliminar usuario",
					"content": "Esto marcará al usuario como eliminado y desactivará sus mascotas (soft delete). ¿Continuar?\n\n{name}\n{email}",
					"confirm": "Eliminar"
				},
				"deleteForever": {
					"title": "Eliminar definitivamente",
					"content": "Esta acción es permanente y elimina al usuario de la base de datos.\n\n{name}\n{email}",
					"confirm": "Eliminar definitivamente"
				},
				"restore": {
					"title": "Restaurar usuario",
					"content": "Esto restaurará al usuario y las mascotas desactivadas con esa exclusión. ¿Continuar?\n\n{name}\n{email}",
					"confirm": "Restaurar"
				},
				"success": {
					"resendVerification": "Correo de verificación reenviado."
				},
				"errors": {
					"load": "No se pudieron cargar los usuarios.",
					"updateStatus": "No se pudo actualizar el estado del usuario.",
					"delete": "No se pudo eliminar el usuario.",
					"deleteForever": "No se pudo eliminar definitivamente el usuario.",
					"restore": "No se pudo restaurar el usuario.",
					"resendVerification": "No se pudo reenviar el correo de verificación."
				}
			},
			"audit": {
				"loading": "Cargando auditoría",
				"filters": {
					"sourceLabel": "Origen",
					"sourceAuth": "Autenticación",
					"sourceActions": "Acciones administrativas",
					"emailLabel": "Correo",
					"emailPlaceholder": "Filtrar por correo",
					"eventLabel": "Evento",
					"eventPlaceholder": "Filtrar por evento",
					"actionLabel": "Acción",
					"actionPlaceholder": "Filtrar por acción",
					"entityTypeLabel": "Tipo de entidad",
					"entityTypePlaceholder": "Filtrar por tipo de entidad"
				},
				"columns": {
					"event": "Evento",
					"email": "Correo",
					"userId": "Usuario",
					"action": "Acción",
					"entityType": "Tipo",
					"entityId": "ID de entidad",
					"entityName": "Entidad",
					"actorUserId": "ID del actor",
					"actorName": "Actor",
					"ip": "IP",
					"country": "País",
					"createdAt": "Fecha",
					"actions": "Acciones"
				},
				"empty": {
					"title": "Sin registros de auditoría",
					"description": "Los registros de autenticación y acciones administrativas aparecerán aquí."
				},
				"noResults": {
					"title": "No se encontraron registros",
					"description": "Intente ajustar los filtros para encontrar lo que busca."
				},
				"actions": {
					"metadataAria": "Ver metadatos"
				},
				"metadata": {
					"title": "Metadatos",
					"close": "Cerrar"
				},
				"errors": {
					"load": "No fue posible cargar los registros de auditoría."
				}
			},
			"dashboard": {
				"close": "Cerrar",
				"loading": "Cargando dashboard",
				"refreshing": "Actualizando datos…",
				"tabs": {
					"aria": "Pestañas del dashboard admin",
					"pets": "Mascotas",
					"vaccines": "Vacunas",
					"others": "Otros",
					"exams": "Exámenes"
				},
				"period": {
					"from": "Desde",
					"to": "Hasta",
					"apply": "Aplicar",
					"petsHint": "Filtra por el período de registro de la mascota y por tutor. Se actualiza automáticamente.",
					"vaccinesHint": "Filtra por el período en que se aplicó la vacuna. Se actualiza automáticamente.",
					"examsHint": "Filtra exámenes realizados por la fecha del resultado (resulted_at / performed_at). Se actualiza automáticamente."
				},
				"stats": {
					"petsTotal": "Total de mascotas",
					"petsActive": "Mascotas activas",
					"withMicrochip": "Con microchip",
					"withoutMicrochip": "Sin microchip",
					"weighedRecent": "Pesados en los últimos 6 meses",
					"weighedStale": "Sin pesaje hace +6 meses",
					"neverWeighed": "Nunca pesados",
					"applicationsTotal": "Aplicaciones",
					"petsVaccinated": "Mascotas vacunadas",
					"resultsTotal": "Exámenes realizados",
					"petsWithResults": "Mascotas con exámenes",
					"panelResultsTotal": "Ítems de paneles",
					"typeResultsTotal": "Exámenes individuales"
				},
				"filters": {
					"title": "Filtros",
					"tutor": "Tutor",
					"allTutors": "Todo el sistema",
					"species": "Especie",
					"allSpecies": "Todas las especies",
					"examKind": "Tipo de examen",
					"allExamKinds": "Todos los tipos",
					"category": "Categoría",
					"allCategories": "Todas las categorías",
					"petSearch": "Buscar mascota",
					"petSearchPlaceholder": "Nombre de la mascota"
				},
				"charts": {
					"bySpecies": "Por especie",
					"byAge": "Por franja etaria",
					"byGender": "Por sexo",
					"byBreed": "Por raza",
					"byBreedEmpty": "Ninguna mascota con raza registrada en el filtro actual.",
					"byWeightStatus": "Por estado de pesaje",
					"byWeightStatusEmpty": "Sin datos de pesaje en el filtro actual.",
					"byCreatedMonth": "Registros por mes",
					"byPetSpecies": "Mascotas vacunadas por especie",
					"byMonth": "Aplicaciones por mes",
					"byKind": "Por tipo de vacuna",
					"byContext": "Por contexto de aplicación",
					"byLocationType": "Por tipo de lugar",
					"applicationsSeries": "Aplicaciones",
					"registrationsSeries": "Registros",
					"axis": {
						"species": "Especie",
						"gender": "Sexo",
						"breed": "Raza",
						"month": "Mes",
						"kind": "Tipo de vacuna",
						"context": "Contexto",
						"locationType": "Tipo de lugar",
						"count": "Cantidad",
						"examKind": "Tipo de examen",
						"category": "Categoría"
					},
					"examsByPetSpecies": "Mascotas con exámenes por especie",
					"resultsByMonth": "Exámenes realizados por mes",
					"resultsByMonthEmpty": "No hay exámenes realizados en el período filtrado.",
					"byExamKind": "Por tipo de examen",
					"byExamCategory": "Por categoría del catálogo",
					"byExamCategoryEmpty": "No hay categorías disponibles para el filtro actual.",
					"resultsSeries": "Exámenes realizados"
				},
				"age": {
					"puppy": "Cachorro",
					"adult": "Adulto",
					"senior": "Senior",
					"unknown": "Desconocido",
					"hint": "Definición de las franjas etarias:",
					"puppyHint": "Cachorro: hasta 11 meses",
					"adultHint": "Adulto: de 1 año hasta 6 años y 11 meses",
					"seniorHint": "Senior: 7 años o más",
					"unknownHint": "Desconocido: sin fecha de nacimiento"
				},
				"labels": {
					"unknown": "No informado"
				},
				"others": {
					"empty": "Ningún ítem en la cola",
					"emptyTitle": "Cola al día",
					"openFullQueue": "Abrir cola completa",
					"promoteSuccess": "Ítem promovido correctamente.",
					"dismissSuccess": "Ítem descartado correctamente.",
					"applications": "Aplicaciones",
					"typeKind": "Tipo",
					"typeProduct": "Producto",
					"dismiss": "Descartar",
					"promote": "Promover",
					"cancel": "Cancelar",
					"confirmPromote": "Confirmar",
					"codeLabel": "Código",
					"defaultNameLabel": "Nombre predeterminado",
					"commercialNameLabel": "Nombre comercial",
					"kindLabel": "Tipo de vacuna",
					"kindPlaceholder": "Seleccione el tipo",
					"speciesLabel": "Especies"
				},
				"errors": {
					"load": "No se pudo cargar el dashboard.",
					"loadPets": "No se pudo cargar el dashboard de mascotas.",
					"loadVaccines": "No se pudo cargar el dashboard de vacunas.",
					"loadOthers": "No se pudo cargar la cola de revisión.",
					"dismiss": "No se pudo descartar el ítem.",
					"promote": "No se pudo promover el ítem.",
					"speciesRequired": "Seleccione al menos una especie.",
					"kindRequired": "Seleccione el tipo de vacuna.",
					"loadExams": "No se pudo cargar el dashboard de exámenes."
				},
				"petsTable": {
					"title": "Mascotas con exámenes realizados",
					"subtitle": "{{total}} mascota(s) en el filtro actual",
					"emptyTitle": "Ninguna mascota encontrada",
					"empty": "No hay mascotas con exámenes realizados para los filtros seleccionados.",
					"openExams": "Abrir exámenes",
					"prev": "Anterior",
					"next": "Siguiente",
					"page": "Página {{page}} de {{total}}",
					"columns": {
						"pet": "Mascota",
						"species": "Especie",
						"results": "Resultados",
						"lastResult": "Último resultado",
						"actions": "Acciones"
					}
				}
			},
			"myData": {
				"saveSuccess": "Datos guardados con éxito.",
				"saveFailed": "No se pudo guardar. Inténtalo de nuevo.",
				"loadFailed": "No se pudieron cargar tus datos.",
				"loading": "Cargando tus datos…",
				"clearColor": "Restaurar color predeterminado",
				"tabsAria": "Pestañas de mis datos",
				"tabs": {
					"profile": "Datos personales",
					"alerts": "Notificaciones"
				},
				"form": {
					"fullNameLabel": "Nombre completo",
					"fullNamePlaceholder": "Tu nombre completo",
					"preferredNameLabel": "Nombre preferido",
					"preferredNamePlaceholder": "Cómo prefieres que te llamen",
					"emailLabel": "Correo",
					"emailPlaceholder": "tu@ejemplo.com",
					"phoneLabel": "Teléfono",
					"phonePlaceholder": "(11) 99999-9999",
					"themeColorLabel": "Color del sistema",
					"themeColorTooltip": "Color para uso personalizado en el sistema. Cambia abajo para probar. Es necesario guardar para registrar la información."
				},
				"push": {
					"title": "Push notifications",
					"description": "Receive glucose curve alerts on this device (pet owner only). Best with installed PWA.",
					"enable": "Enable notifications",
					"disable": "Disable notifications",
					"enabled": "Notifications enabled.",
					"disabled": "Notifications disabled.",
					"failed": "Could not change notifications.",
					"unsupported": "Este navegador no admite Web Push."
				},
				"alerts": {
					"hiddenTitle": "Ocultar alertas",
					"hiddenDescription": "Elige qué tipos de alerta no deben aparecer en la lista, resumen o página de alertas.",
					"saveSuccess": "Preferencias de alertas guardadas.",
					"saveFailed": "No se pudieron guardar las preferencias de alertas.",
					"hideKind": {
						"preventive": "Ocultar alerta: Preventivos",
						"vaccine": "Ocultar alerta: Vacunas",
						"glycemia": "Ocultar alerta: Glicemia",
						"treatment": "Ocultar alerta: Tratamientos",
						"visit": "Ocultar alerta: Consultas",
						"weight": "Ocultar alerta: Peso",
						"birthday": "Ocultar alerta: Cumpleaños"
					}
				}
			}
		}
	},
	"settings": {
		"preventives": {
			"tabs": {
				"brands": "Fabricantes",
				"products": "Productos"
			},
			"active": "Activo",
			"showDeleted": "Mostrar eliminados",
			"filters": {
				"search": "Buscar"
			},
			"actions": "Acciones",
			"edit": "Editar",
			"delete": "Eliminar",
			"cancel": "Cancelar",
			"brands": {
				"name": "Fabricante",
				"createTitle": "Registrar fabricante",
				"editTitle": "Editar fabricante"
			},
			"products": {
				"name": "Nombre comercial",
				"brand": "Fabricante",
				"category": "Categoría",
				"method": "Método",
				"species": "Especies",
				"protectionValue": "Duración de protección",
				"protectionUnit": "Tiempo",
				"aliases": "Alias (separados por coma)",
				"isOther": "Producto Otro",
				"notes": "Notas",
				"createTitle": "Registrar producto",
				"editTitle": "Editar producto"
			},
			"empty": {
				"brands": {
					"title": "Ningún fabricante registrado",
					"description": "Registra el primer fabricante del catálogo."
				},
				"products": {
					"title": "Ningún producto registrado",
					"description": "Registra el primer producto del catálogo."
				}
			},
			"noResults": {
				"title": "Ningún resultado encontrado",
				"description": "Intenta ajustar los filtros para encontrar lo que buscas."
			},
			"errors": {
				"load": "No se pudo cargar el catálogo.",
				"save": "No se pudo guardar el catálogo.",
				"species": "Seleccione al menos una especie.",
				"delete": "No se pudo eliminar el elemento."
			},
			"success": {
				"save": "Catálogo guardado correctamente.",
				"delete": "Elemento eliminado correctamente."
			}
		}
	},
	"breeds": {
		"notInformed": "No informado",
		"breedPlaceholder": "Seleccione la raza",
		"otherBreedLabel": "Descripción de la raza",
		"otherBreedPlaceholder": "Indique la raza",
		"coatLabel": "Pelaje",
		"coatLengthLabel": "Longitud del pelaje",
		"coatColorsLabel": "Colores del pelaje",
		"coatColorsSearch": "Buscar color",
		"otherColorLabel": "Otro color",
		"otherColorPlaceholder": "Describa el color",
		"lengths": {
			"hairless": "Sin pelo",
			"short": "Corta",
			"medium": "Media",
			"long": "Larga"
		},
		"colors": {
			"white": "Blanco",
			"black": "Negro",
			"gray": "Gris",
			"silver": "Plateado",
			"blue": "Azul",
			"brown": "Marrón",
			"chocolate": "Chocolate",
			"liver": "Hígado",
			"tan": "Tan",
			"cream": "Crema",
			"beige": "Beige",
			"fawn": "Leonado",
			"yellow": "Amarillo",
			"golden": "Dorado",
			"orange": "Naranja",
			"red": "Rojo",
			"cinnamon": "Canela",
			"lilac": "Lila",
			"caramel": "Caramelo",
			"sable": "Sable",
			"smoke": "Smoke",
			"other": "Otro"
		}
	},
	"infos": {
		"photo": "Foto",
		"selectPhoto": "Seleccionar foto",
		"removePhoto": "Eliminar foto",
		"name": "Nombre",
		"age": "Edad",
		"birth": "Nacimiento",
		"adoptionTime": "Tiempo de adopción",
		"adoptionDate": "Fecha de adopción",
		"specie": "Especie",
		"race": "Raza",
		"sex": "Sexo",
		"coat": "Pelaje",
		"microchip": "Microchip",
		"microchipAbsent": "No tiene microchip",
		"themeColor": "Color del animal en el sistema",
		"themeColorTooltip": "Color para uso personalizado en el sistema. Cambie abajo para probar. Es necesario hacer clic en guardar para registrar la información.",
		"photoUpload": {
			"selected": "Foto \"{{fileName}}\" seleccionada. Haga clic en guardar para registrar.",
			"dropzone": "Arrastra y suelta la foto aquí",
			"dropActive": "Suelta la foto para subir",
			"browse": "o haz clic para buscar",
			"constraints": "Formatos aceptados: JPG, PNG, WebP hasta 5MB",
			"disabled": "Subida de foto deshabilitada",
			"uploading": "Subiendo foto...",
			"existingMeta": "Imagen pet",
			"cropAction": "Editar imagen (recortar)",
			"cancelUploadAria": "Cancelar envío",
			"removeFileAria": "Eliminar archivo",
			"invalidFileType": "Tipo de archivo no permitido",
			"fileTooLarge": "El archivo supera el tamaño máximo (__MAX_SIZE__)",
			"uploadFailed": "No se pudo subir el archivo",
			"unknownExtension": "ARCHIVO",
			"cropper": {
				"title": "Recortar imagen",
				"cancel": "Cancelar",
				"apply": "Aplicar recorte",
				"zoom": "Zoom",
				"ratio": "Proporción",
				"rotateLeftAria": "Girar a la izquierda",
				"rotateRightAria": "Girar a la derecha",
				"aspectFree": "Libre",
				"aspectSquare": "Cuadrado (1:1)",
				"aspectFourThree": "4:3",
				"aspectSixteenNine": "16:9"
			}
		},
		"previewExpand": "Ampliar imagen",
		"healthCare": {
			"success": "Salud y cuidados actualizados con éxito.",
			"errors": {
				"genericTitle": "Error al guardar",
				"genericMessage": "No se pudieron guardar los datos de salud y cuidados. Inténtelo de nuevo."
			},
			"neuteredStatus": {
				"label": "Castrado",
				"options": {
					"yes": "Sí",
					"no": "No",
					"unknown": "Desconocido"
				}
			},
			"castrationDate": {
				"label": "Fecha de castración"
			},
			"origin": {
				"label": "Origen del animal",
				"options": {
					"breeder": "Criador",
					"shelter": "Refugio / ONG",
					"rescue": "Rescate",
					"born_at_home": "Nacido en casa",
					"other": "Otro"
				}
			},
			"originOther": {
				"label": "Origen — Otro",
				"placeholder": "Describa el origen del animal"
			},
			"livingEnvironment": {
				"label": "Ambiente de vida",
				"options": {
					"indoor_only": "Interior — solo dentro de casa",
					"outdoor_yard_only": "Exterior — solo fuera de casa (patio)",
					"outdoor_yard_street_access": "Exterior — fuera de casa (patio + acceso libre a la calle)",
					"mixed_no_street_access": "Mixto — dentro y fuera sin acceso libre a la calle",
					"mixed_with_street_access": "Mixto — dentro y fuera con acceso libre a la calle"
				}
			},
			"allergies": {
				"label": "Alergias",
				"placeholder": "Describa las alergias conocidas del animal (medicamentos, alimentos, ambientales, etc.)"
			},
			"feeding": {
				"label": "Alimentación",
				"placeholder": "Nombre del alimento o dieta habitual",
				"labelTooltip": "Nombre de la ración o describa la alimentación diaria del animal, como alimentación natural y lo que come"
			}
		},
		"new": {
			"title": "Registrar mascota",
			"subtitle": "Complete los datos a continuación para registrar su mascota en el sistema"
		},
		"time": {
			"and": "y",
			"year": "{count, plural, one {# año} other {# años}}",
			"month": "{count, plural, one {# mes} other {# meses}}",
			"day": "{count, plural, one {# día} other {# días}}"
		}
	},
	"loading": {
		"trying": "Cargando...",
		"noResults": "No se encontró información",
		"endOfList": "Fin de los resultados"
	},
	"menu": {
		"expand": "Expandir menú",
		"collapse": "Contraer menú",
		"language": {
			"label": "Idioma",
			"ariaLabel": "Idioma actual",
			"options": {
				"pt": "Portugués",
				"en": "Inglés",
				"es": "Español",
				"fr": "Francés"
			}
		},
		"principal": {
			"title": "Mascotas",
			"profiles": {
				"master": {
					"title": "Gestión de mascotas",
					"subtitle": "Gestiona tus mascotas y consulta mascotas de otros tutores cuando sea necesario"
				},
				"vet": {
					"title": "Mascotas compartidas conmigo",
					"subtitle": "Acompaña mascotas autorizadas por tutores y consulta su historial"
				},
				"user": {
					"title": "Mis mascotas",
					"subtitle": "Acompaña tus mascotas, alertas e información importante en un solo lugar"
				}
			},
			"type": "pet",
			"petsList": "Lista de mascotas",
			"alerts": "Alertas",
			"registerPet": "Registrar mascota"
		},
		"pet": {
			"title": "Mascota",
			"overview": {
				"title": "Resumen",
				"subtitle": "Resumen de la información de salud y cuidados de la mascota"
			},
			"alerts": {
				"title": "Alertas",
				"subtitle": "Alertas y pendientes de esta mascota"
			},
			"edit": {
				"title": "Editar mascota",
				"subtitle": "Actualiza los datos básicos de tu mascota",
				"tabs": {
					"general": "Información General",
					"healthCare": "Salud y cuidados",
					"feeding": "Alimentación",
					"access": "Accesos",
					"aria": "Secciones de edición de la mascota"
				},
				"success": "Mascota actualizada con éxito.",
				"errors": {
					"conflictTitle": "No se pudo guardar",
					"conflictMessage": "Ya existe un registro con estos datos.",
					"invalidTitle": "Datos inválidos",
					"invalidMessage": "Revise los campos e intente nuevamente.",
					"forbiddenTitle": "Sin permiso",
					"forbiddenMessage": "Su sesión puede haber expirado. Inicie sesión nuevamente.",
					"photoTooLargeTitle": "Foto demasiado grande",
					"photoTooLargeMessage": "La imagen supera el límite de 5 MB. Elija un archivo más pequeño.",
					"photoTypeTitle": "Formato no compatible",
					"photoTypeMessage": "Use una imagen JPG, PNG o WebP.",
					"genericTitle": "Error al guardar la mascota",
					"genericMessage": "Inténtelo de nuevo en unos instantes."
				}
			},
			"new": {
				"success": "Mascota registrada con éxito.",
				"errors": {
					"conflictTitle": "No se pudo registrar",
					"conflictMessage": "Ya existe un registro con estos datos.",
					"invalidTitle": "Datos inválidos",
					"invalidMessage": "Revise los campos e intente nuevamente.",
					"forbiddenTitle": "Sin permiso",
					"forbiddenMessage": "Su sesión puede haber expirado. Inicie sesión nuevamente.",
					"photoTooLargeTitle": "Foto demasiado grande",
					"photoTooLargeMessage": "La imagen supera el límite de 5 MB. Elija un archivo más pequeño.",
					"photoTypeTitle": "Formato no compatible",
					"photoTypeMessage": "Use una imagen JPG, PNG o WebP.",
					"genericTitle": "Error al registrar la mascota",
					"genericMessage": "Inténtelo de nuevo en unos instantes."
				}
			},
			"weight": {
				"title": "Pesos",
				"subtitle": "Historial de pesaje y evolución del peso"
			},
			"preventives": {
				"title": "Preventivos",
				"subtitle": "Control de antipulgas y desparasitación",
				"type": "Preventivo",
				"new": "Nuevo registro",
				"newSubtitle": "Registre la aplicación de un preventivo",
				"edit": "Editar registro",
				"editSubtitle": "Actualice los datos del preventivo"
			},
			"veterinaryConsultation": {
				"title": "Consultas",
				"subtitle": "Historial de consultas veterinarias",
				"type": "Consulta",
				"new": "Nueva visita al veterinario",
				"newSubtitle": "Registre la consulta y los hallazgos clínicos principales",
				"edit": "Editar visita al veterinario",
				"editSubtitle": "Actualice la información de la consulta"
			},
			"vaccines": {
				"title": "Vacunas",
				"subtitle": "Registro de vacunas aplicadas a la mascota",
				"type": "Vacuna",
				"new": "Nueva aplicación de vacuna",
				"newSubtitle": "Indique el contexto, el lugar y los datos de la aplicación",
				"edit": "Editar aplicación de la vacuna",
				"editSubtitle": "Actualice los datos de la aplicación de vacuna"
			},
			"examsResults": {
				"title": "Resultados de exámenes",
				"subtitle": "Resultados e historial de exámenes solicitados en las consultas",
				"type": "Exámenes",
				"new": "Nuevo resultado de examen",
				"newSubtitle": "Registre exámenes históricos con fecha, valores y archivos",
				"edit": "Editar resultado de examen",
				"editSubtitle": "Actualice los datos del pedido y los valores"
			},
			"examsResultsDetails": {
				"title": "Detalles de los resultados del examen",
				"subtitle": "Información del examen realizado"
			},
			"examsComparisons": {
				"title": "Comparaciones de exámenes",
				"subtitle": "Evolución y rango de referencia",
				"type": "Exámenes"
			},
			"treatments": {
				"title": "Tratamientos",
				"subtitle": "Tratamientos continuos o temporales",
				"type": "Tratamiento",
				"new": "Nuevo tratamiento",
				"newSubtitle": "Registre un tratamiento en curso o temporal",
				"edit": "Editar tratamiento",
				"editSubtitle": "Actualice la información del tratamiento",
				"view": "Ver tratamiento",
				"viewSubtitle": "Plan finalizado — solo se pueden añadir notas"
			},
			"clinicalConditions": {
				"title": "Condiciones clínicas",
				"subtitle": "Enfermedades y condiciones de salud monitoreadas",
				"type": "Condición",
				"details": "Condición: {name}",
				"detailsSubtitle": "Siga el historial y las notas de esta condición",
				"new": "Nueva condición clínica",
				"newSubtitle": "Registre una condición clínica de la mascota",
				"edit": "Editar condición clínica",
				"editSubtitle": "Actualice los datos de la condición clínica"
			},
			"glucoseCurveMeasures": {
				"title": "Mediciones glucémicas",
				"subtitle": "Seguimiento de las mediciones de la curva glucémica",
				"type": "Medición",
				"new": "Nueva medición de la curva glucémica",
				"newSubtitle": "Registre una nueva sesión de curva glucémica",
				"details": "Medición del {date}",
				"detailsFallback": "Medición",
				"detailsSubtitle": "Detalles y puntos de la curva glucémica"
			},
			"glucoseCurveComparison": {
				"title": "Comparación glucémica",
				"subtitle": "Evolución de la glucemia a lo largo del tiempo",
				"type": "Medición"
			},
			"glycemia": {
				"title": "Glucemia",
				"subtitle": "Control diario, curva y comparación"
			}
		},
		"vet": {
			"title": "Mis mascotas compartidas",
			"subtitle": "Elige una mascota para ver su información e historial"
		},
		"admin": {
			"title": "Administración",
			"dashboard": "Dashboard",
			"dashboardSubtitle": "Resumen de mascotas, aplicaciones de vacunas y cola de revisión",
			"typesOfVaccines": "Vacuna",
			"typesOfVaccinesSubtitle": "Tipos, marcas, productos y cola de revisión de textos libres",
			"preventivesCatalog": "Preventivos",
			"preventivesCatalogSubtitle": "Marcas y productos preventivos",
			"diseases": "Enfermedades",
			"diseasesSubtitle": "Registre y gestione enfermedades vinculadas a vacunas y condiciones",
			"breeds": "Razas",
			"breedsSubtitle": "Razas, colores de pelaje y cola de revisión",
			"exams": "Exámenes",
			"examsSubtitle": "Catálogo, paneles, auditoría e importaciones de exámenes",
			"typesOfExams": "Tipos de exámenes",
			"typesOfExamsSubtitle": "Registre tipos de examen y referencias del sistema",
			"examinationPackage": "Paquetes de exámenes",
			"examinationPackageSubtitle": "Arme paquetes con conjuntos de exámenes",
			"adminUsers": "Usuarios del sistema",
			"adminUsersSubtitle": "Gestione tutores, veterinarios y estado de acceso",
			"audit": "Auditoría",
			"auditSubtitle": "Registros de autenticación y acciones administrativas",
			"myDataSubtitle": "Datos personales y preferencias de notificaciones"
		},
		"fixed": {
			"myData": "Mi cuenta",
			"mySettings": "Mis configuraciones",
			"logout": "Cerrar sesión"
		},
		"goBackTo": {
			"principal": "Volver a las mascotas"
		}
	},
	"overview": {
		"microchipAbsent": "No tiene",
		"titles": {
			"infos": "Información sobre mascotas",
			"nextVaccines": "Próximas vacunas",
			"lastWeighIns": "Últimos pesajes",
			"glycemicCurve": "Curva de glucosa",
			"glycemicCurveComparison": "Comparación de las últimas curvas"
		},
		"fields": {
			"microchip": "Microchip"
		},
		"weights": {
			"from": "Desde",
			"to": "Hasta",
			"startDate": "Fecha inicial",
			"endDate": "Fecha final",
			"dateAxis": "Fecha",
			"weightAxis": "Peso (kg)",
			"lastWeighIn": "Último pesaje:",
			"onDate": "el",
			"noRecords": "Sin registros",
			"gained": "ganó",
			"lost": "perdió",
			"maintained": "mantuvo",
			"inPeriod": "en el período.",
			"open": "Registrar / Ver pesos",
			"errors": {
				"endBeforeStart": "La fecha final no puede ser anterior a la inicial.",
				"sameDates": "Las fechas no pueden ser iguales. Seleccione dos distintas."
			}
		},
		"glycemia": {
			"measurementDate": "Fecha de la medición:",
			"minimum": "Mín:",
			"maximum": "Máx:",
			"average": "Promedio:",
			"clicks": "clics",
			"register": "Registrar glucemia",
			"viewMeasurement": "Ver medición realizada"
		},
		"completeness": {
			"title": "Información pendiente",
			"lead": "Campos básicos e importantes aún sin completar en esta mascota:",
			"badgeOk": "Completo",
			"badgeMissing": "{count} pendiente(s)",
			"emptyTitle": "Toda la información básica e importante está completa",
			"emptyDescription": "Perfil general, salud/cuidado, vacunas y peso están bien en esta mascota.",
			"vaccinesTotal": "Vacunas registradas",
			"weightsTotal": "Pesos registrados",
			"fields": {
				"microchip": "Microchip",
				"birthDate": "Fecha de nacimiento",
				"adoptionDate": "Fecha de adopción",
				"breed": "Raza",
				"coatLength": "Largo del pelaje",
				"coatColors": "Color del pelaje",
				"neuteredStatus": "Castrado (sí / no / desconocido)",
				"castrationDate": "Fecha de castración",
				"origin": "Origen del animal",
				"livingEnvironment": "Ambiente de vida",
				"feeding": "Alimentación",
				"vaccines": "Ninguna vacuna registrada",
				"weights": "Ningún peso registrado"
			}
		}
	},
	"toast": {
		"successTitle": "¡Éxito!",
		"errorTitle": "¡Error!",
		"warningTitle": "Atención",
		"infoTitle": "Información"
	},
	"uiKit": {
		"form": {
			"selectPlaceholder": "Seleccionar",
			"searchPlaceholder": "Buscar...",
			"searchAriaLabel": "Buscar opción",
			"emptyOptions": "No se encontraron opciones",
			"clearSelectionAria": "Limpiar selección"
		},
		"table": {
			"paginationAria": "Paginación de la tabla",
			"paginationTopSuffix": "(superior)",
			"paginationBottomSuffix": "(inferior)",
			"previous": "Anterior",
			"next": "Siguiente",
			"first": "Primera",
			"last": "Última",
			"page": "Página",
			"of": "de",
			"total": "registro(s)",
			"pageSizeAria": "Elementos por página",
			"sortBy": "Ordenar por __COLUMN__",
			"sortAsc": "ascendente",
			"sortDesc": "descendente"
		},
		"modal": {
			"confirm": "Confirmar",
			"cancel": "Cancelar",
			"close": "Cerrar",
			"closeAria": "Cerrar modal"
		},
		"toast": {
			"closeAria": "Cerrar notificación"
		},
		"loading": {
			"ariaLabel": "Cargando contenido"
		},
		"tabs": {
			"ariaLabel": "Pestañas"
		},
		"breadcrumb": {
			"ariaLabel": "Migas de pan"
		},
		"switch": {
			"active": "Activado",
			"inactive": "Desactivado"
		},
		"button": {
			"loading": "Cargando..."
		},
		"alert": {
			"closeAria": "Cerrar alerta"
		},
		"fileUpload": {
			"pdfBadge": "pdf"
		}
	},
	"vaccines": {
		"kinds": {
			"BORDETELLA": "Bordetella",
			"FELV": "FeLV",
			"GIARDIA": "Giardia",
			"LEISHMANIASIS": "Leishmaniosis",
			"CANINE_PUPPY": "Puppy",
			"RABIES": "Rabia",
			"TOSSE": "Tos y gripe canina",
			"CANINE_V10": "V10",
			"CANINE_V11": "V11",
			"FELINE_V3": "V3",
			"FELINE_V4": "V4",
			"FELINE_V5": "V5",
			"CANINE_V6": "V6",
			"CANINE_V8": "V8",
			"OTHER": "Otra"
		},
		"diseases": {
			"RABIES": "Rabia",
			"CANINE_DISTEMPER": "Moquillo",
			"CANINE_ADENOVIRUS": "Adenovirus / Hepatitis",
			"CANINE_PARVOVIRUS": "Parvovirus",
			"CANINE_PARAINFLUENZA": "Parainfluenza",
			"LEPTOSPIROSIS": "Leptospirosis",
			"BORDETELLA": "Bordetella / Tos de las perreras",
			"GIARDIA": "Giardia",
			"LEISHMANIASIS": "Leishmaniosis",
			"FELINE_HERPESVIRUS": "Herpesvirus felino",
			"FELINE_CALICIVIRUS": "Calicivirus felino",
			"FELINE_PANLEUKOPENIA": "Panleucopenia felina",
			"FELINE_CHLAMYDIA": "Clamidiosis felina",
			"FELINE_LEUKEMIA": "Leucemia felina (FeLV)"
		},
		"dose": {
			"unique": "única",
			"nth": "{n}ª dosis",
			"last": "última dosis"
		},
		"product": {
			"notInformed": "No informada"
		},
		"context": {
			"consultation": "Consulta veterinaria",
			"home": "Atención domiciliaria",
			"campaign": "Campaña pública",
			"shelter_ngo": "ONG / Refugio",
			"hospital": "Hospital veterinario",
			"breeder": "Criador (criadero)",
			"university": "Universidad",
			"other": "Otro"
		},
		"visitType": {
			"routine": "Rutina",
			"return": "Retorno",
			"emergency": "Urgencia"
		},
		"visitMode": {
			"in_person": "Presencial",
			"home": "Domicilio",
			"tele": "Teleconsulta"
		},
		"locationType": {
			"clinic": "Clínica",
			"home": "Residencia",
			"public_event": "Evento / campaña",
			"shelter": "Refugio / ONG",
			"hospital": "Hospital",
			"breeder": "Criador",
			"university": "Universidad",
			"pet_shop": "Pet shop",
			"other": "Otro"
		},
		"form": {
			"kindLabel": "Tipo de vacuna",
			"kindPlaceholder": "Seleccione el tipo…",
			"productLabel": "Producto / marca comercial",
			"productPlaceholder": "Seleccione el producto…",
			"otherKindLabel": "Nombre del tipo",
			"otherKindPlaceholder": "Indique el tipo de vacuna",
			"otherProductLabel": "Nombre del producto",
			"otherProductPlaceholder": "Indique el producto",
			"doseLabel": "Dosis",
			"contextLabel": "Contexto de la aplicación",
			"contextPlaceholder": "Seleccione el contexto…",
			"locationNameLabel": "Lugar",
			"locationNamePlaceholder": "Buscar clínica o lugar",
			"clinicOther": "Otro",
			"clinicNameLabel": "Nombre del lugar",
			"clinicNamePlaceholder": "Ej.: Clínica X, refugio…",
			"homeLocationFixed": "Residencia",
			"visitTypeLabel": "Tipo de consulta",
			"visitTypePlaceholder": "Seleccione el tipo…",
			"visitModeLabel": "Modalidad de consulta",
			"visitModePlaceholder": "Seleccione la modalidad…",
			"weightLabel": "Peso (kg)",
			"weightPlaceholder": "Ej.: 4,5",
			"weightReplaceTitle": "¿Sustituir el peso del día?",
			"weightReplaceDescription": "Ya existe un peso de {existing} kg en este día. ¿Desea sustituirlo por {next} kg?",
			"weightReplaceConfirm": "Sustituir",
			"weightReplaceSkip": "Mantener peso actual",
			"visitLabel": "Consulta relacionada",
			"visitPlaceholder": "Seleccione la consulta…",
			"administeredAtLabel": "Aplicada el",
			"administeredAtTimeLabel": "Hora",
			"nextDoseLabel": "Próxima dosis",
			"administeredByLabel": "Profesional",
			"vetCrmvLabel": "CRMV",
			"vetCrmvPlaceholder": "Ej.: CRMV-SP 12345",
			"clinicLabel": "Clínica",
			"notesLabel": "Observaciones / efectos",
			"notesPlaceholder": "Anote reacciones, efectos o complicaciones…",
			"visitInternalNotes": "Aplicación de vacuna",
			"kindOrProductHint": "Puede elegir el tipo, el producto, o solo el producto — el tipo se completa automáticamente.",
			"dosesSingular": "1 dosis",
			"dosesPlural": "{count} dosis",
			"successSave": "Vacuna guardada correctamente.",
			"errorSave": "No se pudo guardar la vacuna. Inténtelo de nuevo.",
			"addVaccine": "Agregar vacuna",
			"removeVaccine": "Quitar vacuna",
			"sectionTitle": "Vacunas aplicadas",
			"vaccinesSectionHint": "Para cada vacuna aplicada en este día, indique el tipo, el producto y la fecha de la próxima dosis.",
			"cancel": "Cancelar"
		}
	},
	"preventives": {
		"form": {
			"loading": "Cargando preventivo…",
			"appliedAtLabel": "Fecha de aplicación",
			"kindLabel": "Cuál",
			"kindPlaceholder": "Seleccione…",
			"methodLabel": "Tipo",
			"methodPlaceholder": "Seleccione…",
			"productLabel": "Producto",
			"productPlaceholder": "Ej.: NexGard, Bravecto…",
			"productCatalogPlaceholder": "Busque un producto…",
			"otherProduct": "Otro / no listado",
			"otherProductLabel": "Nombre del producto",
			"protectionValueLabel": "Duración de protección",
			"protectionValuePlaceholder": "Ej.: 30",
			"protectionUnitLabel": "Tiempo",
			"protectionUnitPlaceholder": "Seleccione…",
			"unitDays": "Días",
			"unitMonths": "Meses",
			"recurringLabel": "Aplicación recurrente",
			"recurringTooltip": "Si está marcado, genera una alerta en el inicio según la próxima dosis.",
			"nextDueAtLabel": "Próxima dosis",
			"calculateNextDue": "Calcular próxima fecha",
			"recalculate": "Recalcular",
			"autoSuggestion": "Sugerencia automática: {date}",
			"weightLabel": "Peso del día (kg)",
			"weightPlaceholder": "Ej.: 4,5",
			"weightReplaceTitle": "¿Sustituir el peso del día?",
			"weightReplaceDescription": "Ya existe un peso de {existing} kg en este día. ¿Desea sustituirlo por {next} kg?",
			"weightReplaceConfirm": "Sustituir",
			"weightReplaceSkip": "Mantener peso actual",
			"notesLabel": "Observaciones",
			"notesPlaceholder": "Añada observaciones",
			"cancel": "Cancelar",
			"success": {
				"create": "Preventivo guardado con éxito.",
				"update": "Preventivo actualizado con éxito."
			},
			"errors": {
				"load": "No se pudo cargar el preventivo.",
				"save": "No se pudo guardar el preventivo.",
				"recalculate": "No se pudo recalcular la próxima dosis."
			},
			"sourceTreatmentLabel": "Tratamiento de origen",
			"sourceTreatmentPlaceholder": "Vincular a un tratamiento"
		},
		"categories": {
			"pulgas_carrapatos": "Pulgas y garrapatas",
			"pulgas": "Pulgas",
			"vermifugo": "Vermífugo",
			"vermifugo_dirofilariose": "Vermífugo y dirofilariosis",
			"combo_interno_externo": "Protección interna y externa",
			"outro": "Otro"
		},
		"methods": {
			"comprimido": "Comprimido",
			"injecao": "Inyección",
			"coleira": "Collar",
			"pipeta": "Pipeta",
			"spray": "Spray",
			"shampoo": "Champú",
			"liquido": "Líquido",
			"pasta": "Pasta",
			"outro": "Otro"
		}
	},
	"appUpdate": {
		"title": "Nueva versión disponible",
		"message": "Hay una actualización lista. Actualice para cargar textos y correcciones nuevas.",
		"reload": "Actualizar ahora",
		"later": "Después",
		"errorTitle": "Actualización",
		"unrecoverable": "La aplicación necesita recargarse para continuar."
	},
	"offline": {
		"banner": "Sin conexión. Los datos de este formulario permanecen en este dispositivo y podrán enviarse cuando vuelva la conexión."
	},
	"weight": {
		"loading": "Cargando historial de pesos",
		"readOnlyInfo": "Solo el tutor de la mascota puede registrar o eliminar pesos.",
		"unit": {
			"kg": "kg"
		},
		"form": {
			"panelTitle": "Registrar nuevo peso"
		},
		"tabs": {
			"aria": "Vistas del peso",
			"summary": "Resumen",
			"stats": "Estadística",
			"timeline": "Línea de tiempo"
		},
		"summary": {
			"initial": "Peso inicial",
			"current": "Peso actual",
			"last": "Último peso",
			"trend": "Tendencia"
		},
		"trend": {
			"up": "Aumento de peso",
			"down": "Pérdida de peso",
			"flat": "Peso estable"
		},
		"stats": {
			"loading": "Cargando estadísticas",
			"periodNote": "* Datos estadísticos basados en los últimos 12 meses.",
			"insufficient": {
				"title": "Datos insuficientes",
				"description": "Se necesitan al menos 2 registros de peso en los últimos 12 meses para mostrar las estadísticas."
			},
			"max": "Mayor peso",
			"min": "Menor peso",
			"average": "Peso medio",
			"averageBasis": "Basado en {count} registros",
			"amplitude": "Amplitud",
			"amplitudeMeta": "Entre el menor y el mayor peso",
			"lastWeighing": "Última pesada",
			"lastWeighingToday": "Hoy",
			"lastWeighingOneDay": "Hace 1 día",
			"lastWeighingDays": "Hace {days} días",
			"ratePerWeek": "Variación media",
			"ratePerWeekMeta": "Del primer al último registro del período",
			"ratePerWeekValue": "{value} kg/semana",
			"frequency": "Frecuencia",
			"frequencyMeta": "Intervalo medio entre registros",
			"frequencyDays": "Cada {days} días",
			"frequencyOneDay": "Diaria en promedio",
			"notAvailable": "—",
			"trend": "Tendencia",
			"error": {
				"title": "No se pudieron cargar las estadísticas",
				"description": "Ocurrió un error al calcular las estadísticas de peso. Inténtelo de nuevo.",
				"retry": "Reintentar"
			}
		},
		"timeline": {
			"sortAria": "Alternar el orden de la línea de tiempo",
			"sortNewest": "Más recientes primero",
			"sortOldest": "Más antiguos primero",
			"loadingMore": "Cargando más registros"
		},
		"empty": {
			"title": "Ningún peso registrado",
			"description": "¡Siga el desarrollo de su mascota! ¡El peso es extremadamente importante!",
			"descriptionReadOnly": "No hay peso registrado para esta mascota."
		},
		"loadError": {
			"title": "No se pudieron cargar los pesos",
			"description": "Ocurrió un error al obtener el historial de pesos. Inténtelo de nuevo.",
			"retry": "Reintentar"
		},
		"errors": {
			"save": "No se pudo guardar el peso. Inténtelo de nuevo.",
			"duplicateDate": "Ya existe un peso registrado ese día",
			"delete": "No se pudo eliminar el registro. Inténtelo de nuevo.",
			"loadMore": "No se pudieron cargar más registros."
		},
		"success": {
			"save": "Peso registrado correctamente.",
			"delete": "Registro de peso eliminado."
		},
		"delete": {
			"title": "¿Eliminar registro de peso?",
			"contentWithRecord": "Esta acción no se puede deshacer. Registro: {record}",
			"contentGeneric": "Esta acción no se puede deshacer.",
			"confirm": "Eliminar",
			"cancel": "Cancelar"
		},
		"actions": {
			"deleteAria": "Eliminar registro de peso"
		}
	},
	"feeding": {
		"loading": "Cargando alimentación",
		"historyTitle": "Historial",
		"changedFeeding": "Cambié la alimentación",
		"stoppedFeeding": "Dejé de darla",
		"stop": {
			"title": "Detener alimentación",
			"description": "¿Deseas finalizar \"{product}\"? Pasará al historial y no será reemplazada.",
			"confirm": "Detener",
			"cancel": "Cancelar"
		},
		"history": {
			"from": "De: {date}",
			"to": "Hasta: {date}"
		},
		"card": {
			"since": "Desde {date}",
			"notesPrefix": "Obs.: "
		},
		"empty": {
			"activeTitle": "Ninguna alimentación registrada",
			"activeDescription": "Registra la comida o dieta actual de la mascota para seguir los cambios con el tiempo.",
			"historyTitle": "Sin historial",
			"historyDescription": "Cuando se reemplace una alimentación, aparecerá aquí."
		},
		"form": {
			"titleAdd": "Agregar alimento",
			"titleChange": "Cambié la alimentación",
			"type": "Tipo",
			"product": "Producto",
			"productPlaceholder": "Selecciona un producto del catálogo",
			"productOther": "Otro",
			"brandName": "Marca",
			"brandNamePlaceholder": "Ej.: Royal Canin",
			"productName": "Nombre del producto",
			"productNamePlaceholder": "Ej.: croqueta adult, comida natural",
			"flavor": "Sabor",
			"flavorPlaceholder": "Ej.: pollo",
			"purpose": "Finalidad",
			"format": "Formato",
			"frequencyUnit": "Frecuencia",
			"frequencyTimes": "Veces",
			"frequencyTimesPlaceholder": "Ej.: 2",
			"frequencyOther": "Describe la frecuencia",
			"frequencyOtherPlaceholder": "Ej.: cada 2 días, solo fines de semana",
			"startDate": "Fecha de inicio",
			"endDate": "Fecha de fin de la anterior",
			"notes": "Observaciones",
			"notesPlaceholder": "Añada observaciones"
		},
		"type": {
			"dry_food": "Comida seca",
			"wet_food": "Comida húmeda",
			"natural_home_cooked": "Natural casera",
			"natural_commercial": "Natural comercial",
			"raw_diet": "Dieta cruda (BARF)",
			"milk_formula": "Fórmula / leche",
			"enteral_diet": "Dieta enteral",
			"other": "Otro"
		},
		"purpose": {
			"maintenance": "Mantenimiento",
			"growth": "Crecimiento",
			"weight_control": "Control de peso",
			"therapeutic": "Terapéutica",
			"recovery": "Recuperación",
			"senior": "Senior",
			"other": "Otro"
		},
		"format": {
			"kibble": "Croqueta",
			"sachet": "Sobre",
			"can": "Lata",
			"pate": "Paté",
			"mousse": "Mousse",
			"frozen": "Congelado",
			"refrigerated": "Refrigerado",
			"dehydrated": "Deshidratado",
			"freeze_dried": "Liofilizado",
			"liquid": "Líquido",
			"other": "Otro"
		},
		"frequency": {
			"unit": {
				"day": "Por día",
				"week": "Por semana",
				"free": "Libre",
				"other": "Otra"
			},
			"label": {
				"day": "{times}x por día",
				"week": "{times}x por semana",
				"free": "Libre (siempre disponible)"
			}
		},
		"success": {
			"create": "Alimento agregado correctamente.",
			"change": "Alimentación actualizada correctamente.",
			"stop": "Alimentación finalizada correctamente."
		},
		"errors": {
			"loadTitle": "No se pudo cargar",
			"loadMessage": "Ocurrió un error al cargar la alimentación. Inténtalo de nuevo.",
			"saveTitle": "No se pudo guardar",
			"saveMessage": "Revisa los campos e inténtalo de nuevo.",
			"stopMessage": "No se pudo finalizar la alimentación. Inténtalo de nuevo."
		}
	},
	"table": {
		"totalCount": "<span class='hide-mobile'>Total de </span><strong>{ total }</strong> registros"
	},
	"noResults": {
		"vaccines": "No más vacunas"
	}
}
